
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("f788Q", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $513b3aabfa44d17f$export$2cd8252107eb640b; });
// NOTE: This file must be kept in sync with the changes in:
// - init.tsx

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $9jv6U = parcelRequire("9jv6U");

var $01JF1 = parcelRequire("01JF1");

var $cGDYS = parcelRequire("cGDYS");

var $7RyUO = parcelRequire("7RyUO");

var $dunoe = parcelRequire("dunoe");

var $k2OeR = parcelRequire("k2OeR");

var $j0nzO = parcelRequire("j0nzO");

var $jpi63 = parcelRequire("jpi63");

var $6wlNh = parcelRequire("6wlNh");

var $9uFWm = parcelRequire("9uFWm");

var $EyEcw = parcelRequire("EyEcw");

var $9Dbz6 = parcelRequire("9Dbz6");
window.BUILD_KEY = "p-c4971f54a1-prod-experiment";
window.featureGateBootstrapValues = window.featureGateBootstrapValues || {
    identifiers: {
        analyticsAnonymousId: (0, $cGDYS.default)()
    }
};
const $513b3aabfa44d17f$var$BASE_URL = "https://www.atlassian.com";
const $513b3aabfa44d17f$var$SUPPORTED_LOCALES = [
    {
        hrefLang: "ja",
        langRoute: "ja"
    },
    {
        hrefLang: "fr",
        langRoute: "fr"
    },
    {
        hrefLang: "de",
        langRoute: "de"
    },
    {
        hrefLang: "es",
        langRoute: "es"
    },
    {
        hrefLang: "pt-BR",
        langRoute: "br"
    },
    {
        hrefLang: "zh-Hans",
        langRoute: "zh"
    },
    {
        hrefLang: "ko",
        langRoute: "ko"
    },
    {
        hrefLang: "ru",
        langRoute: "ru"
    },
    {
        hrefLang: "pl",
        langRoute: "pl"
    },
    {
        hrefLang: "it",
        langRoute: "it"
    },
    {
        hrefLang: "nl",
        langRoute: "nl"
    }
];
const $513b3aabfa44d17f$export$2cd8252107eb640b = (Component)=>{
    const isStatic = typeof window !== "undefined" && window.IS_STATIC;
    const analyticsWebClient = (0, $dunoe.getAnalyticsWebClient)();
    const { locale: locale, path: path } = (0, $9Dbz6.parseRoute)(window.location);
    const route = path !== "" ? "/" + path : "";
    // Get location data for experiments and feature gates from server-provided data
    let locationData;
    // Use server-provided data (no client-side API calls)
    if (typeof window !== "undefined") locationData = {
        countryIsoCode: window.countryCode || "",
        regionIsoCode: window.regionIsoCode || ""
    };
    const isPerfOnetrustEnabled = (0, $k2OeR.isPerformanceOnetrustEnabled)(document.cookie, locationData);
    isPerfOnetrustEnabled && (0, $7RyUO.initUFO)(analyticsWebClient, path);
    const parsedClientCookies = document.cookie ? (0, $9jv6U.parse)(document.cookie) : {};
    const userAgent = typeof window !== "undefined" ? window.navigator.userAgent : "";
    const { finalExperimentOverrides: finalExperimentOverrides, finalFeatureGateOverrides: finalFeatureGateOverrides } = (0, $EyEcw.processExperimentAndFeatureGateOverrides)(parsedClientCookies, userAgent, isPerfOnetrustEnabled);
    // Below is for debugging edge - will be removed
    window.ssrAnonId = window.featureGateBootstrapValues.identifiers.analyticsAnonymousId;
    // We can't feature gate below code as this is done before initialization so just overriding for the path we are testing
    if ((0, $6wlNh.isEdgeCachingPath)(window.location.pathname)) {
        // Override for Edge Caching
        (0, $6wlNh.overrideAjsAnonIdFromCookie)();
        (0, $6wlNh.overrideCustomAttributes)();
    }
    (0, $j0nzO.initializeFeatureGatesClient)(window.featureGateBootstrapValues, {
        overrideValues: {
            experimentOverrides: finalExperimentOverrides,
            featureGateOverrides: finalFeatureGateOverrides
        },
        // if performance cookies are disabled, we will skip exposures
        localMode: !isPerfOnetrustEnabled
    }).then(()=>{
        const page = /*#__PURE__*/ (0, $loA2J.jsxs)((0, $9uFWm.SentryIntlProvider), {
            locale: locale,
            messages: window.SSR_languagePack,
            cookies: document.cookie,
            children: [
                isStatic && /*#__PURE__*/ (0, $loA2J.jsx)("link", {
                    rel: "canonical",
                    href: `${$513b3aabfa44d17f$var$BASE_URL}${route}`
                }),
                isStatic && /*#__PURE__*/ (0, $loA2J.jsx)("link", {
                    rel: "alternate",
                    href: `${$513b3aabfa44d17f$var$BASE_URL}${route}`,
                    hrefLang: "x-default"
                }),
                isStatic && $513b3aabfa44d17f$var$SUPPORTED_LOCALES.map(({ hrefLang: hrefLang, langRoute: langRoute })=>/*#__PURE__*/ (0, $loA2J.jsx)("link", {
                        rel: "alternate",
                        href: `${$513b3aabfa44d17f$var$BASE_URL}/${langRoute}${route}`,
                        hrefLang: hrefLang
                    }, hrefLang)),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $jpi63.PageWrapper), {
                    analyticsWebClient: analyticsWebClient,
                    location: window.location,
                    pricing: window.prices,
                    availableProducts: window.availableProducts,
                    userProfile: window.userProfile,
                    userProfileStatus: window.userProfileStatus,
                    userContext: window.userContext,
                    userContextStatus: window.userContextStatus,
                    loggedOutContext: window.loggedOutContext,
                    loggedOutContextStatus: window.loggedOutContextStatus,
                    countryCode: window.countryCode,
                    templates: window.templates,
                    partnerTemplates: window.partnerTemplates,
                    collections: window.collections,
                    categories: window.categories,
                    composition: window._uniformPreloadedComposition,
                    isUniformPlayground: window.isUniformPlayground,
                    teamType: window.teamType,
                    keyword: window.keyword,
                    referrer: window.referrer,
                    mlTemplateIds: window.mlTemplateIds,
                    track: window.track,
                    anchor: window.anchor,
                    subAnchor: window.subAnchor,
                    auxiaResponse: window.auxiaResponse,
                    PageComponent: Component,
                    transactionAccounts: window.transactionAccounts,
                    userAgent: userAgent,
                    clusterTag: window.clusterTag
                })
            ]
        });
        if (isStatic) {
            // @ts-ignore
            const root = (0, $01JF1.createRoot)(document.getElementById("wac"));
            root.render(page);
        } else (0, $01JF1.hydrateRoot)(// @ts-ignore
        document.getElementById("wac-root"), page, {
            onRecoverableError: (error, errorInfo)=>{
                var _document_getElementById;
                (_document_getElementById = document.getElementById("wac-root")) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.setAttribute("hydration-error", "true");
            }
        });
    });
};

});

parcelRegister("cIqek", function(module, exports) {
$parcel$export(module.exports, "Adg4RaisedMedia", function () { return (parcelRequire("eGxBJ")).Adg4RaisedMedia; });
parcelRequire("eGxBJ");

});
parcelRegister("eGxBJ", function(module, exports) {

$parcel$export(module.exports, "Adg4RaisedMedia", function () { return $87cd6c26a4a4ed0a$export$bfa1278d9934b266; });
/* raised-media.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
const $87cd6c26a4a4ed0a$var$raisedImage = null;
const $87cd6c26a4a4ed0a$export$bfa1278d9934b266 = ({ className: className, children: children })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_16qs1qw3 _2rko1crf _1e0c1txw _1reo15vq _18m915vq",
            className
        ]),
        children: children
    });
};

});


parcelRegister("ctYD4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::451c857042316b193f6451d1ac5153c9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9167392384132023$var$_react = $9167392384132023$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $9167392384132023$var$_baseNew = $9167392384132023$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $9167392384132023$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Comment".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for comments on objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9167392384132023$var$CommentIcon = (props)=>/*#__PURE__*/ $9167392384132023$var$_react.default.createElement($9167392384132023$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125v8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25zM2.625 2C2.004 2 1.5 2.504 1.5 3.125v10.833L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125v-8.25C14.5 2.504 13.996 2 13.375 2zM12 6.5H4V5h8zm-3 3H4V8h5z" clip-rule="evenodd"/>`
    }, props));
$9167392384132023$var$CommentIcon.displayName = "CommentIcon";
var $9167392384132023$var$_default = module.exports.default = $9167392384132023$var$CommentIcon;

});

parcelRegister("fPKMu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cca747bf584e772ee6e9df3631122996>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b86fe83597f76dc8$var$_react = $b86fe83597f76dc8$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $b86fe83597f76dc8$var$_baseNew = $b86fe83597f76dc8$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $b86fe83597f76dc8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Incident".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for incidents in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b86fe83597f76dc8$var$IncidentIcon = (props)=>/*#__PURE__*/ $b86fe83597f76dc8$var$_react.default.createElement($b86fe83597f76dc8$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1a.75.75 0 0 1 .696.471l2.2 5.5 2.612 6.529H15V15H1v-1.5h1.492L7.304 1.471A.75.75 0 0 1 8 1M4.108 13.5h7.784l-.8-2H4.908zm1.4-3.5h4.984l-.8-2H6.308zm1.4-3.5h2.184L8 3.77z" clip-rule="evenodd"/>`
    }, props));
$b86fe83597f76dc8$var$IncidentIcon.displayName = "IncidentIcon";
var $b86fe83597f76dc8$var$_default = module.exports.default = $b86fe83597f76dc8$var$IncidentIcon;

});

parcelRegister("gTkVc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::69f4e6f87c1306b0b7d1107d65930cc1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c4c203016fffe508$var$_react = $c4c203016fffe508$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $c4c203016fffe508$var$_baseNew = $c4c203016fffe508$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $c4c203016fffe508$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Person".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c4c203016fffe508$var$PersonIcon = (props)=>/*#__PURE__*/ $c4c203016fffe508$var$_react.default.createElement($c4c203016fffe508$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m-2 9a3.75 3.75 0 0 1 3.75-3.75h4.5A3.75 3.75 0 0 1 14 13v2h-1.5v-2a2.25 2.25 0 0 0-2.25-2.25h-4.5A2.25 2.25 0 0 0 3.5 13v2H2z" clip-rule="evenodd"/>`
    }, props));
$c4c203016fffe508$var$PersonIcon.displayName = "PersonIcon";
var $c4c203016fffe508$var$_default = module.exports.default = $c4c203016fffe508$var$PersonIcon;

});

parcelRegister("aRHrH", function(module, exports) {
$parcel$export(module.exports, "IntercomProvider", function () { return (parcelRequire("9O2F2")).IntercomProvider; });
parcelRequire("9O2F2");
parcelRequire("42XIn");

});
parcelRegister("9O2F2", function(module, exports) {

$parcel$export(module.exports, "IntercomProvider", function () { return $be094a112486886f$export$5091c5023e5c7eba; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $l4i0P = parcelRequire("l4i0P");

var $gkhN4 = parcelRequire("gkhN4");

var $7OS3I = parcelRequire("7OS3I");
const $be094a112486886f$var$isWindowExist = typeof window !== "undefined";
const $be094a112486886f$export$e578ca56db818a8e = /*#__PURE__*/ $iSvIT.createContext(undefined);
const $be094a112486886f$export$5091c5023e5c7eba = ({ appId: appId, triggerBoot: triggerBoot = false, children: children })=>{
    const isBooted = $iSvIT.useRef(false);
    const isInit = $iSvIT.useRef(false);
    const stargateClient = (0, $gkhN4.useBxpWebStargateClient)();
    const initIntercomInstance = $iSvIT.useCallback(()=>{
        if (!isInit.current) {
            (0, $7OS3I.default)(appId);
            isInit.current = true;
        }
    }, [
        appId
    ]);
    // Ensure DOM is fully ready and stable before Intercom initialization
    const ensureDOMReady = $iSvIT.useCallback(()=>{
        return new Promise((resolve)=>{
            if (document.readyState === "complete") // DOM is ready, but add buffer time for iframe stability
            setTimeout(resolve, 500);
            else {
                // Wait for DOM completion, then add buffer time
                const cleanup = ()=>{
                    document.removeEventListener("DOMContentLoaded", handleLoad);
                    window.removeEventListener("load", handleLoad);
                };
                const handleLoad = ()=>{
                    cleanup();
                    clearTimeout(safetyTimeout);
                    setTimeout(resolve, 500);
                };
                // Add event listeners for DOM ready
                document.addEventListener("DOMContentLoaded", handleLoad);
                window.addEventListener("load", handleLoad);
                // Safety timeout: resolve after 10 seconds even if events don't fire
                const safetyTimeout = setTimeout(()=>{
                    cleanup();
                    console.error("Intercom: DOM ready timeout reached, proceeding anyway");
                    resolve();
                }, 10000);
            }
        });
    }, []);
    const boot = $iSvIT.useCallback(async ()=>{
        if ($be094a112486886f$var$isWindowExist && isInit.current && !isBooted.current) {
            var _window_intercomSettings;
            const intercomSettings = (_window_intercomSettings = window.intercomSettings) !== null && _window_intercomSettings !== void 0 ? _window_intercomSettings : {
                app_id: appId
            };
            try {
                var _window_Intercom, _window, _window_Intercom1, _window1;
                // Wait for DOM to be fully ready and stable
                await ensureDOMReady();
                (_window_Intercom = (_window = window).Intercom) === null || _window_Intercom === void 0 ? void 0 : _window_Intercom.call(_window, "boot", (0, $7Knp0._)({
                    alignment: "right",
                    horizontal_padding: 20,
                    vertical_padding: 20,
                    custom_launcher_selector: "#intercomLauncher"
                }, intercomSettings));
                (_window_Intercom1 = (_window1 = window).Intercom) === null || _window_Intercom1 === void 0 ? void 0 : _window_Intercom1.call(_window1, "trackEvent", "widget-loaded");
            } catch (error) {
                console.warn("Intercom boot failed:", error);
            } finally{
                isBooted.current = true; // Set value as true to enable functionality of show/hide methods
            }
        }
    }, [
        appId,
        ensureDOMReady
    ]);
    const shutdown = $iSvIT.useCallback(()=>{
        if (!isBooted.current) return;
        if ($be094a112486886f$var$isWindowExist) {
            var _window_Intercom, _window;
            (_window_Intercom = (_window = window).Intercom) === null || _window_Intercom === void 0 ? void 0 : _window_Intercom.call(_window, "shutdown");
            delete window.intercomSettings;
            isBooted.current = false;
        }
    }, []);
    const show = $iSvIT.useCallback(()=>{
        var _window_Intercom, _window;
        if ($be094a112486886f$var$isWindowExist && isBooted.current) (_window_Intercom = (_window = window).Intercom) === null || _window_Intercom === void 0 ? void 0 : _window_Intercom.call(_window, "show");
    }, []);
    const hide = $iSvIT.useCallback(()=>{
        var _window_Intercom, _window;
        if ($be094a112486886f$var$isWindowExist && isBooted.current) (_window_Intercom = (_window = window).Intercom) === null || _window_Intercom === void 0 ? void 0 : _window_Intercom.call(_window, "hide");
    }, []);
    $iSvIT.useEffect(()=>{
        if ($be094a112486886f$var$isWindowExist && triggerBoot) (async function() {
            const intercomSettingsObj = {
                app_id: appId
            };
            const anonId = (0, $l4i0P.default).get("ajs_anonymous_id") || "";
            if (anonId) intercomSettingsObj["anonymousId"] = anonId;
            const getwayApiMeGetResponse = await stargateClient.me({}).catch(()=>null);
            if (getwayApiMeGetResponse) {
                intercomSettingsObj["name"] = getwayApiMeGetResponse.name;
                intercomSettingsObj["email"] = getwayApiMeGetResponse.email;
            }
            if ($be094a112486886f$var$isWindowExist) window.intercomSettings = intercomSettingsObj;
            if (!isInit.current) initIntercomInstance();
            if (isInit.current && !isBooted.current) boot();
        })();
        // clean up code
        return ()=>{
            if (isInit.current) shutdown();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        triggerBoot,
        stargateClient
    ]);
    const providerValue = $iSvIT.useMemo(()=>{
        return {
            initIntercomInstance: initIntercomInstance,
            boot: boot,
            shutdown: shutdown,
            show: show,
            hide: hide
        };
    }, [
        initIntercomInstance,
        boot,
        shutdown,
        show,
        hide
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)($be094a112486886f$export$e578ca56db818a8e.Provider, {
        value: providerValue,
        children: children
    });
};
const $be094a112486886f$export$28418e623d2470bc = ()=>{
    const context = $iSvIT.useContext($be094a112486886f$export$e578ca56db818a8e);
    if (context === undefined) throw new Error("This hook must be used within IntercomProvider");
    return context;
};

});
parcelRegister("7OS3I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f03bd135604494e$export$2e2bcd8739ae039; });
function $9f03bd135604494e$var$isIELikeWindow(w) {
    return Object.prototype.hasOwnProperty.call(w, "attachEvent");
}
// Function per instruction here: https://developers.intercom.com/installing-intercom/web/installation/
const $9f03bd135604494e$var$initializeIntercomInstance = (appId)=>{
    const w = window;
    const ic = w.Intercom;
    if (typeof ic === "function") {
        ic("reattach_activator");
        ic("update", w.intercomSettings);
    } else {
        const d = document;
        const i = function() {
            i.c(arguments);
        };
        i.q = [];
        i.c = function(args) {
            i.q.push(args);
        };
        w.Intercom = i;
        const l = function() {
            var _x_parentNode;
            const s = d.createElement("script");
            s.type = "text/javascript";
            s.async = true;
            s.src = "https://widget.intercom.io/widget/" + appId;
            const x = d.getElementsByTagName("script")[0];
            x === null || x === void 0 ? void 0 : (_x_parentNode = x.parentNode) === null || _x_parentNode === void 0 ? void 0 : _x_parentNode.insertBefore(s, x);
        };
        if (document.readyState === "complete") l();
        else if ($9f03bd135604494e$var$isIELikeWindow(w)) w.attachEvent("onload", l);
        else w.addEventListener("load", l, false);
    }
};
var $9f03bd135604494e$export$2e2bcd8739ae039 = $9f03bd135604494e$var$initializeIntercomInstance;

});


parcelRegister("42XIn", function(module, exports) {
// Intercom Types & Interface ===========================================================
// all the Interface stuff from: https://developers.intercom.com/installing-intercom/web/attributes-objects/

});


parcelRegister("isSvf", function(module, exports) {
$parcel$export(module.exports, "Video", function () { return (parcelRequire("lxS8L")).Video; });

$parcel$export(module.exports, "default", function () { return (parcelRequire("lxS8L")).Video; });

var $lxS8L = parcelRequire("lxS8L");

});
parcelRegister("lxS8L", function(module, exports) {

$parcel$export(module.exports, "Video", function () { return $ed253e67f972fd3a$export$ae01dedf5c052bb; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
const $ed253e67f972fd3a$var$videoStyle = (ratio)=>{
    const aspectRatioCSS = ratio && ratio !== "none" ? {
        aspectRatio: ratio,
        objectFit: "cover"
    } : {};
    return (0, $7Knp0._)({
        maxWidth: "100%"
    }, aspectRatioCSS);
};
const $ed253e67f972fd3a$export$ae01dedf5c052bb = ({ videoLink: videoLink, videoType: videoType, videoPreviewImage: videoPreviewImage, loop: loop = true, muted: muted = true, aspectRatio: aspectRatio, alternativeSources: alternativeSources, className: className, fallbackText: fallbackText, onEnded: onEnded, children: children })=>{
    const videoRef = (0, $iSvIT.useRef)(null);
    // reload video player if video source prop changes dynamically
    (0, $iSvIT.useEffect)(()=>{
        var _videoRef_current;
        (_videoRef_current = videoRef.current) === null || _videoRef_current === void 0 ? void 0 : _videoRef_current.load();
    }, [
        videoLink
    ]);
    return(// eslint-disable-next-line jsx-a11y/media-has-caption
    /*#__PURE__*/ (0, $loA2J.jsxs)("video", {
        playsInline: true,
        muted: muted,
        preload: "auto",
        poster: videoPreviewImage,
        autoPlay: true,
        className: className,
        style: $ed253e67f972fd3a$var$videoStyle(aspectRatio),
        loop: loop,
        ref: videoRef,
        onEnded: onEnded,
        children: [
            fallbackText,
            /*#__PURE__*/ (0, $loA2J.jsx)("source", {
                src: videoLink,
                type: `video/${videoType ? videoType : "mp4"}`
            }),
            alternativeSources ? alternativeSources.map((source, index)=>{
                return /*#__PURE__*/ (0, $loA2J.jsx)("source", {
                    src: source.videoLink,
                    type: `video/${source.videoType ? source.videoType : "mp4"}`
                }, index);
            }) : null,
            children
        ]
    }));
};

});


parcelRegister("1FqEx", function(module, exports) {

$parcel$export(module.exports, "useParentScrollTracking", function () { return $5f5c2bfbd45e6855$export$164ddb76b909974a; });
$parcel$export(module.exports, "ParentScrollTracking", function () { return $5f5c2bfbd45e6855$export$248f1dfc9396e7e4; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
parcelRequire("ccYBS");
var $e6FyV = parcelRequire("e6FyV");
const $5f5c2bfbd45e6855$var$ScrollTrackingContext = /*#__PURE__*/ (0, $iSvIT.createContext)({
    pageId: "wac-web",
    scrollTrackingEnabled: true
});
const $5f5c2bfbd45e6855$export$164ddb76b909974a = ()=>{
    return (0, $iSvIT.useContext)($5f5c2bfbd45e6855$var$ScrollTrackingContext);
};
const $5f5c2bfbd45e6855$export$248f1dfc9396e7e4 = (props)=>{
    const parentContext = $5f5c2bfbd45e6855$export$164ddb76b909974a();
    const arrayChildren = (0, $iSvIT.Children).toArray(props.children);
    const definedName = (child)=>{
        if (/*#__PURE__*/ (0, $iSvIT.isValidElement)(child) && child.type) {
            // Use a type assertion to tell TypeScript that the type has a displayName
            const namedComponent = child.type;
            return namedComponent.displayName;
        } else return undefined;
    };
    // Determine tracking of parent undefined means true
    const parentTrackScrolling = parentContext.scrollTrackingEnabled === undefined ? true : parentContext.scrollTrackingEnabled;
    // Parent should take precedence if parent tracking is disabled
    const trackScrolling = parentTrackScrolling && (props.scrollTrackingEnabled === undefined ? true : props.scrollTrackingEnabled);
    var _props_pageId;
    const pageId = (_props_pageId = props.pageId) !== null && _props_pageId !== void 0 ? _props_pageId : parentContext.pageId;
    return /*#__PURE__*/ (0, $loA2J.jsx)($5f5c2bfbd45e6855$var$ScrollTrackingContext.Provider, {
        value: {
            pageId: pageId,
            scrollTrackingEnabled: trackScrolling
        },
        children: (0, $iSvIT.Children).map(arrayChildren, (child, index)=>{
            const name = definedName(child);
            return name ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $e6FyV.ScrollTracking), {
                index: `${index}/${arrayChildren.length}`,
                section: name,
                as: props.as,
                children: child
            }, index) : child;
        })
    });
};

});
parcelRegister("ccYBS", function(module, exports) {
$parcel$export(module.exports, "ScrollTracking", function () { return (parcelRequire("e6FyV")).ScrollTracking; });
$parcel$export(module.exports, "useScrollTracking", function () { return (parcelRequire("e6FyV")).useScrollTracking; });
$parcel$export(module.exports, "withScrollTracking", function () { return (parcelRequire("e6FyV")).withScrollTracking; });
$parcel$export(module.exports, "ParentScrollTracking", function () { return (parcelRequire("1FqEx")).ParentScrollTracking; });
parcelRequire("e6FyV");
parcelRequire("1FqEx");

});
parcelRegister("e6FyV", function(module, exports) {

$parcel$export(module.exports, "useScrollTracking", function () { return $dd17d79dac682b5f$export$17700584f55fbc70; });
$parcel$export(module.exports, "ScrollTracking", function () { return $dd17d79dac682b5f$export$1725757b7947b890; });
$parcel$export(module.exports, "withScrollTracking", function () { return $dd17d79dac682b5f$export$391633ede08dabb1; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $eDoPe = parcelRequire("eDoPe");

var $g9kzu = parcelRequire("g9kzu");

var $1FqEx = parcelRequire("1FqEx");

var $dWbel = parcelRequire("dWbel");
const $dd17d79dac682b5f$export$17700584f55fbc70 = (section, props = {})=>{
    const { index: index, observerOptions: observerOptions, dwellTimeEnabled: dwellTimeEnabled, additionalAttributes: additionalAttributes } = props;
    const hasFunctionBeenCalled = (0, $iSvIT.useRef)(false);
    const scrollPercentage = (0, $iSvIT.useRef)(0);
    const { pageId: pageId, scrollTrackingEnabled: scrollTrackingEnabled } = (0, $1FqEx.useParentScrollTracking)();
    const { ref: ref, inView: inView, entry: entry } = (0, $eDoPe.useInView)((0, $6iHNw._)((0, $7Knp0._)({
        threshold: 0.5,
        triggerOnce: true
    }, observerOptions), {
        skip: (observerOptions === null || observerOptions === void 0 ? void 0 : observerOptions.skip) || !scrollTrackingEnabled
    }));
    const analyticsClient = (0, $dWbel.useAnalyticsClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const handleScroll = ()=>{
        const windowHeight = window.innerHeight;
        const fullHeight = document.documentElement.scrollHeight;
        const currentPosition = window.scrollY;
        scrollPercentage.current = Math.round(currentPosition / (fullHeight - windowHeight) * 100);
    };
    (0, $iSvIT.useEffect)(()=>{
        if (inView && !hasFunctionBeenCalled.current && section) {
            handleScroll();
            const scrollTrackAnalyticsPayload = {
                eventType: "ui",
                action: "scrolledTo",
                actionSubject: "section",
                source: window.location.pathname,
                attributes: (0, $7Knp0._)({
                    section: section,
                    scrollPercentage: scrollPercentage.current,
                    pageChildIndex: index,
                    pageId: pageId
                }, additionalAttributes)
            };
            const dwellTimeTrackAnalyticsPayload = {
                eventType: "ui",
                action: "dwellTimeTracked",
                actionSubject: "section",
                source: window.location.pathname,
                attributes: (0, $7Knp0._)({
                    section: section,
                    scrollPercentage: scrollPercentage.current,
                    pageChildIndex: index,
                    pageId: pageId
                }, additionalAttributes)
            };
            if (analyticsClient) {
                createAnalyticsEvent((0, $7Knp0._)({}, scrollTrackAnalyticsPayload)).fire();
                hasFunctionBeenCalled.current = true;
            }
            if (dwellTimeEnabled) {
                const activityEvents = [
                    "mousemove",
                    "keydown",
                    "scroll",
                    "touchstart"
                ];
                let intervalId = undefined;
                let activityTimeout = undefined;
                let active = true;
                // stop tracking after 1 minute of inactivity
                const setActive = ()=>{
                    active = true;
                    clearTimeout(activityTimeout);
                    activityTimeout = setTimeout(()=>{
                        active = false;
                    }, 60000);
                };
                activityEvents.forEach((evt)=>{
                    window.addEventListener(evt, setActive);
                });
                // emmit every 5 seconds if the user is active
                intervalId = setInterval(()=>{
                    if (active) {
                        handleScroll();
                        createAnalyticsEvent((0, $7Knp0._)({}, dwellTimeTrackAnalyticsPayload)).fire();
                    } else {
                        clearInterval(intervalId);
                        clearTimeout(activityTimeout);
                        activityEvents.forEach((evt)=>{
                            window.removeEventListener(evt, setActive);
                        });
                    }
                }, 5000);
            }
        }
    }, [
        additionalAttributes,
        analyticsClient,
        createAnalyticsEvent,
        dwellTimeEnabled,
        hasFunctionBeenCalled,
        inView,
        index,
        pageId,
        section
    ]);
    return {
        ref: ref,
        inView: inView,
        entry: entry
    };
};
const $dd17d79dac682b5f$export$1725757b7947b890 = ({ section: section, index: index, observerOptions: observerOptions, children: children, as: RootElement = "div" })=>{
    const { ref: ref } = $dd17d79dac682b5f$export$17700584f55fbc70(section, {
        index: index,
        observerOptions: observerOptions
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)(RootElement, {
        ref: ref,
        children: children
    });
};
function $dd17d79dac682b5f$export$391633ede08dabb1(section, InnerComponent, options) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (props)=>{
        return /*#__PURE__*/ (0, $loA2J.jsx)($dd17d79dac682b5f$export$1725757b7947b890, (0, $6iHNw._)((0, $7Knp0._)({
            section: section
        }, options), {
            children: /*#__PURE__*/ (0, $loA2J.jsx)(InnerComponent, (0, $7Knp0._)({}, props))
        }));
    };
}

});



parcelRegister("hjMWG", function(module, exports) {

$parcel$export(module.exports, "Adg4Skeleton", function () { return $74c1b43210cd442a$export$e754784845e8828d; });

var $7Knp0 = parcelRequire("7Knp0");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");

var $g2OHD = parcelRequire("g2OHD");

var $kwHar = parcelRequire("kwHar");

var $5ohHq = parcelRequire("5ohHq");
const $74c1b43210cd442a$export$e754784845e8828d = (_param)=>{
    var { width: width, height: height, groupName: groupName, testId: testId } = _param, props = (0, $akGnX._)(_param, [
        "width",
        "height",
        "groupName",
        "testId"
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $g2OHD.default), (0, $7Knp0._)({
        width: width,
        height: height,
        groupName: groupName,
        testId: testId,
        isShimmering: true,
        borderRadius: (0, $kwHar.default)("space.100"),
        color: (0, $5ohHq.wacToken)("color.neutral.light200"),
        ShimmeringEndColor: (0, $5ohHq.wacToken)("color.neutral.light300")
    }, props));
};

});
parcelRegister("g2OHD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bae429c214074d74$export$2e2bcd8739ae039; });
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8TInU = parcelRequire("8TInU");

var $1tzue = parcelRequire("1tzue");

var $iSvIT = parcelRequire("iSvIT");

var $b8Gks = parcelRequire("b8Gks");
var $k1KzN = parcelRequire("k1KzN");
function $bae429c214074d74$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bae429c214074d74$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bae429c214074d74$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1tzue.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bae429c214074d74$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $bae429c214074d74$var$shimmerKeyframes = null;
var $bae429c214074d74$var$skeletonStyles = null;
var $bae429c214074d74$var$activeShimmerStyles = null;
/**
 * __Skeleton__
 *
 * A skeleton acts as a placeholder for content, usually while the content loads.
 *
 * - [Examples](https://atlassian.design/components/skeleton/examples)
 * - [Code](https://atlassian.design/components/skeleton/code)
 */ var $bae429c214074d74$var$Skeleton = function Skeleton(_ref) {
    var width = _ref.width, height = _ref.height, _ref$borderRadius = _ref.borderRadius, borderRadius = _ref$borderRadius === void 0 ? "100px" : _ref$borderRadius, color = _ref.color, ShimmeringEndColor = _ref.ShimmeringEndColor, _ref$isShimmering = _ref.isShimmering, isShimmering = _ref$isShimmering === void 0 ? false : _ref$isShimmering, groupName = _ref.groupName, testId = _ref.testId;
    var groupDataAttribute = groupName && "data-".concat(groupName);
    return /*#__PURE__*/ $iSvIT.createElement("div", (0, $8TInU.default)({
        "data-testid": testId
    }, groupDataAttribute && (0, $1tzue.default)({}, groupDataAttribute, "true"), {
        className: (0, $b8Gks.default)([
            "_7hjf1yy8 _5sag12o8 _tip812c5 _1pglp3kn _bfhkn82g",
            isShimmering && "",
            isShimmering && "_j7hq586c"
        ]),
        style: $bae429c214074d74$var$_objectSpread($bae429c214074d74$var$_objectSpread({}, {
            width: width,
            height: height,
            borderRadius: borderRadius,
            backgroundColor: color,
            // Override the keyframes if both colors are provided, otherwise use the CSS variable fallbacks in our keyframes
            "--ds-skeleton-from-color": color && ShimmeringEndColor ? color : undefined,
            "--ds-skeleton-to-color": color && ShimmeringEndColor ? ShimmeringEndColor : undefined
        }), {}, {
            "--_wenvhl": (0, $k1KzN.default)("var(--ds-skeleton-from-color, ".concat("var(--ds-skeleton, #091E420F)", ")")),
            "--_1soe2er": (0, $k1KzN.default)("var(--ds-skeleton-to-color, ".concat("var(--ds-skeleton-subtle, #091E4208)", ")"))
        })
    }));
};
var $bae429c214074d74$export$2e2bcd8739ae039 = $bae429c214074d74$var$Skeleton;

});
parcelRegister("8TInU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $67a5e3a84d125062$export$2e2bcd8739ae039; });
function $67a5e3a84d125062$export$2e2bcd8739ae039() {
    return $67a5e3a84d125062$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $67a5e3a84d125062$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("1tzue", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $113406c6bdee5322$export$2e2bcd8739ae039; });

var $k4PRg = parcelRequire("k4PRg");
function $113406c6bdee5322$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $k4PRg.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("k4PRg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e9dc684bfecaec5f$export$2e2bcd8739ae039; });

var $1bWKL = parcelRequire("1bWKL");

var $75jqn = parcelRequire("75jqn");
function $e9dc684bfecaec5f$export$2e2bcd8739ae039(t) {
    var i = (0, $75jqn.default)(t, "string");
    return "symbol" == (0, $1bWKL.default)(i) ? i : i + "";
}

});
parcelRegister("1bWKL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0de464af02e7f83b$export$2e2bcd8739ae039; });
function $0de464af02e7f83b$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $0de464af02e7f83b$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0de464af02e7f83b$export$2e2bcd8739ae039(o);
}

});

parcelRegister("75jqn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $528811526f37b7b7$export$2e2bcd8739ae039; });

var $1bWKL = parcelRequire("1bWKL");
function $528811526f37b7b7$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $1bWKL.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $1bWKL.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("b8Gks", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $81c146b95d18c9fb$export$2e2bcd8739ae039; });
const $81c146b95d18c9fb$var$UNDERSCORE_UNICODE = 95;
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $81c146b95d18c9fb$var$ATOMIC_GROUP_LENGTH = 5;
function $81c146b95d18c9fb$export$2e2bcd8739ae039(classNames) {
    if (classNames.length <= 1 && (!classNames[0] || classNames[0].indexOf(" ") === -1)) // short circuit if there's no custom class names.
    return classNames[0] || undefined;
    const atomicGroups = {};
    for(let i = 0; i < classNames.length; i++){
        const cls = classNames[i];
        if (!cls) continue;
        const groups = cls.split(" ");
        for(let x = 0; x < groups.length; x++){
            const atomic = groups[x];
            const atomicGroupName = atomic.slice(0, atomic.charCodeAt(0) === $81c146b95d18c9fb$var$UNDERSCORE_UNICODE ? $81c146b95d18c9fb$var$ATOMIC_GROUP_LENGTH : undefined);
            atomicGroups[atomicGroupName] = atomic;
        }
    }
    let str = "";
    for(const key in atomicGroups){
        const value = atomicGroups[key];
        str += value + " ";
    }
    return str.slice(0, -1);
}

});

parcelRegister("k1KzN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e94807bc1aa32f2f$export$2e2bcd8739ae039; });
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $e94807bc1aa32f2f$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return "var(--c-, )";
}

});



parcelRegister("47768", function(module, exports) {

$parcel$export(module.exports, "EnhancedBannerAlert", function () { return $6b681fb7f69a74b7$export$e2bb4f4abc9a31da; });
/* enhanced-banner-alert.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $iSvIT = parcelRequire("iSvIT");

var $bhreu = parcelRequire("bhreu");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");

var $4XrxY = parcelRequire("4XrxY");

var $1syhO = parcelRequire("1syhO");
const $6b681fb7f69a74b7$export$e2bb4f4abc9a31da = (bannerInfo)=>{
    const bannerStorageItem = `BannerAlert_dismiss-${bannerInfo.identifier}`;
    const closeIconDataEventProps = {
        "data-product-key": bannerInfo.productKey,
        "data-event-component": "button",
        "data-event-container": "announcementBanner",
        "data-event": "clicked",
        "data-label": "Close",
        "data-label-english": "Close"
    };
    const [isHidden, setIsHidden] = (0, $iSvIT.useState)(true);
    const mobileClass = bannerInfo.mobileTextThirdScreen ? "three-screen" : "two-screen";
    (0, $iSvIT.useEffect)(()=>{
        const dismissValue = (0, $1syhO.getLocalStorage)(bannerStorageItem);
        if (dismissValue !== "1") setIsHidden(false);
    }, [
        bannerStorageItem
    ]);
    let mobileProps = bannerInfo.imageProps;
    if (bannerInfo.imageMobileProps && bannerInfo.imageMobileProps.src) mobileProps = bannerInfo.imageMobileProps;
    const bannerBgPreset = bannerInfo.backgroundPreset ? `bg-${bannerInfo.backgroundPreset}` : `bg-none`;
    const bannerType = bannerInfo.bannerType ? `banner-type-${bannerInfo.bannerType}` : "banner-type-default";
    const bgLinkColor = bannerInfo.backgroundPreset == "gwp-5090-banners" ? "bgBlackBlue" : "bgWhite";
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.TypographyStyles), {
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_bfhk1ybm _kqswh2mm _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _1pbykb7n _85i5yh40 _189eh5ge _1dqonqa1 _5pio2icb _nzmgglyw _1auo1lef _21w0idpf _15641crf _s4s5idpf _1qlo1crf _7j8l1lk2 _jw2n1wug _1yvc1wug _19z9gktf _nue91vuk _1lrfidpf _pytjidpf _smywidpf _4tf1idpf _1dkqidpf _1i8zidpf _1twsidpf _c7u0idpf _1u1bjk2v _1876mq8p _gsz9mgnk _evayglyw _lhr7161t _1cmq12iu _88w1cd5j _5vmz1ejb _3kek1ejb _190eni2e _wb1217a9 _vb1gvgh6 _1at2oyge _49yzdf70 _cfy01ule _18901k92 _1aavidpf _72q2idpf _11sc1y44 _i4q0idpf _n8ff1cby _qho21j28 _1w7d1hlo _sqps1ybm _iawm1hlo _abydglyw _6c4acd5j _udn3glyw _2fl2idpf _1kn8cd5j _1vxmcd5j _1mafcd5j _waepcd5j _1y8xcd5j _1ur0cd5j _ojfccd5j _1yaacd5j _11zscd5j _1s05cd5j _6rr71ybm _fsy11ybm _sx881ybm _1s7h1ybm _1gudcd5j _1m8acd5j _1lcvcd5j _v05mcd5j _lkhdni7l _pu49ni7l _162fni7l _19ycni7l _102q1hbo _2utfmgnk _1vm51dlf _1e74altx _1o3a1izt _1blmu4dp _1si213i1 _1k051ms4 _1yip1f51 _6zpp1f51 _eyt5xchc _nxj7u58z _7w4fcd5j _xfs2idpf _17es1rga _lfur1dgx _1t0kmgnk _ejrwidpf _1m4lanty _7ax8uuw1 _1ww71tcg _cfnoftgi _ogm61et3 _ve7k1ule _1mt7kfja _76j711ux _1dxgidpf _1i4jt1wm _ne8lqiko _1it7ys9h _umq2mgvx _16471dnu _1uhmmr2s _6cysidpf _yo8p1tcg _17pqqslr _ti1kp3fh _onmtn7od",
                `${bannerBgPreset} ${bannerType}`
            ]),
            "data-dismissed": isHidden ? "true" : undefined,
            "data-testid": "banner-alert-container",
            style: (0, $6iHNw._)((0, $7Knp0._)({}, bannerInfo.customCSS), {
                "--_1hkddbi": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue100")),
                "--_e0fbx3": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.purple500")),
                "--_1tgiy09": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue900")),
                "--_1b67llw": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue700")),
                "--_1avknp6": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.secondary.red")),
                "--_1vwzriw": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.yellow")),
                "--_b9m2cq": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.secondary.green")),
                "--_1lpv4ka": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.lime")),
                "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0")),
                "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
                "--_1nu1zxz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light100"))
            }),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                className: (0, $esG4f.default)([
                                    "_1rjcpxbi _1e0c1txw _2lx2vrvc _zulpzwfg _kqswh2mm _6rth12gs _sugaglyw",
                                    "desktop-container"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                        className: (0, $esG4f.default)([
                                            "_1e0c1txw _4cvr1h6o"
                                        ]),
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                                            image: (0, $7Knp0._)({
                                                width: 209
                                            }, bannerInfo.imageProps),
                                            style: {
                                                maxWidth: "100%",
                                                height: "auto"
                                            },
                                            forceEagerLoad: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                        className: (0, $esG4f.default)([
                                            "_191w1xtt _4t3i1osq _sugaglyw",
                                            "line"
                                        ]),
                                        style: {
                                            "--_k3797e": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light700"))
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                        className: (0, $esG4f.default)([
                                            "_1bsb1osq _1e0c1txw _2lx2vrvc _1bah1yb4 _4cvr1h6o _zulpzwfg _na0i1bp4 _dh1a1y6m _2osn14y2 _ag851h6o _10ca1q9c"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                                className: (0, $esG4f.default)([
                                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1pbykb7n",
                                                    "body-md"
                                                ]),
                                                children: bannerInfo.text
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                                                bgColor: bgLinkColor,
                                                text: bannerInfo.linkText,
                                                href: bannerInfo.linkUrl,
                                                type: "primary",
                                                dataEventProps: bannerInfo.dataEventProps
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                className: (0, $esG4f.default)([
                                    "_1rjcpxbi _1e0cglyw _2lx21bp4 _4cvr1h6o _suga1txw",
                                    "mobile-container"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                        className: (0, $esG4f.default)([
                                            "_1e0c11p5 _p12f1osq _18zr7vkz"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                className: (0, $esG4f.default)([
                                                    "_1ii7kb7n _yyhykb7n _1pglp3kn _tip812c5 _ow341opw _ezr91onc _17k8119v _18shrjc5 _1h6z1ule",
                                                    "_19pkidpf _2hwx1wug _otyridpf _18u01wug",
                                                    mobileClass
                                                ]),
                                                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), {
                                                        image: (0, $7Knp0._)({
                                                            width: 180
                                                        }, mobileProps),
                                                        style: {
                                                            maxWidth: "100%",
                                                            height: "auto"
                                                        },
                                                        forceEagerLoad: true
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                className: (0, $esG4f.default)([
                                                    "_1ii7kb7n _yyhykb7n _1pglp3kn _tip812c5 _ow341opw _ezr91onc _17k8119v _18shrjc5 _1h6z1ule",
                                                    "_y3gn1h6o _1mou1wug _tzy4idpf _ju25i11n",
                                                    mobileClass
                                                ]),
                                                children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                                    className: (0, $esG4f.default)([
                                                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1pbykb7n",
                                                        "body-md"
                                                    ]),
                                                    children: bannerInfo.mobileText
                                                })
                                            }),
                                            bannerInfo.mobileTextThirdScreen && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                                className: (0, $esG4f.default)([
                                                    "_1ii7kb7n _yyhykb7n _1pglp3kn _tip812c5 _ow341opw _ezr91onc _17k8119v _18shrjc5 _1h6z1ule",
                                                    "_y3gn1h6o _1mou1wug _tzy4idpf _ju251onc",
                                                    mobileClass
                                                ]),
                                                children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                                    className: (0, $esG4f.default)([
                                                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1pbykb7n",
                                                        "body-md"
                                                    ]),
                                                    children: bannerInfo.mobileTextThirdScreen
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                                        bgColor: bgLinkColor,
                                        text: bannerInfo.linkText,
                                        href: bannerInfo.linkUrl,
                                        type: "primary",
                                        dataEventProps: bannerInfo.dataEventProps
                                    })
                                ]
                            })
                        ]
                    })
                }),
                bannerInfo.bannerType != "lifted" && /*#__PURE__*/ (0, $loA2J.jsx)("button", (0, $6iHNw._)((0, $7Knp0._)({
                    className: (0, $esG4f.default)([
                        "_19itidpf _r06hglyw _bfhk1j28 _80omtlke _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw _1pbykb7n _rjxpidpf _19pk7vkz _2hwx7vkz _otyr7vkz _18u07vkz",
                        `close-button-symbol`
                    ]),
                    "data-testid": "close-button",
                    "aria-label": "Close",
                    onClick: ()=>{
                        setIsHidden(true);
                        (0, $1syhO.setLocalStorage)(bannerStorageItem, "1");
                    }
                }, closeIconDataEventProps), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Cross), {
                        size: "24"
                    })
                }))
            ]
        })
    });
};
const $6b681fb7f69a74b7$var$scrollUpTwoScreens = null;
const $6b681fb7f69a74b7$var$scrollUpThreeScreens = null;
const $6b681fb7f69a74b7$var$desktopContainerStyles = null;
const $6b681fb7f69a74b7$var$mobileContainerStyles = null;
const $6b681fb7f69a74b7$var$desktopLogoStyles = null;
const $6b681fb7f69a74b7$var$marqueeContainerStyles = null;
const $6b681fb7f69a74b7$var$marqueeItemStyle = null;
const $6b681fb7f69a74b7$var$marqueeItem1Styles = null;
const $6b681fb7f69a74b7$var$marqueeItem2Styles = null;
const $6b681fb7f69a74b7$var$marqueeItem3Styles = null;
const $6b681fb7f69a74b7$var$containerStyles = null;
const $6b681fb7f69a74b7$var$contentStyles = null;
const $6b681fb7f69a74b7$var$pStyle = null;
const $6b681fb7f69a74b7$var$lineStyle = null;
const $6b681fb7f69a74b7$var$closeStyles = null;

});

parcelRegister("fovuc", function(module, exports) {
$parcel$export(module.exports, "BannerAlert", function () { return (parcelRequire("5ZfUA")).BannerAlert; });

$parcel$export(module.exports, "default", function () { return (parcelRequire("5ZfUA")).BannerAlert; });

var $5ZfUA = parcelRequire("5ZfUA");

});
parcelRegister("5ZfUA", function(module, exports) {

$parcel$export(module.exports, "BannerAlert", function () { return $a7a242474da496d8$export$4eb8f3e4e539379b; });
/* banner-alert.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable local/ensure-wac-token-usage */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $dyZbY = parcelRequire("dyZbY");

var $1UUq1 = parcelRequire("1UUq1");

var $4XrxY = parcelRequire("4XrxY");

var $1syhO = parcelRequire("1syhO");
const $a7a242474da496d8$var$containerStyles = null;
const $a7a242474da496d8$var$contentStyles = null;
const $a7a242474da496d8$var$closeIconStyles = null; /**
                               * @deprecated - Please use @/libraries/design/components/banner-alert instead
                               */ 
const $a7a242474da496d8$export$4eb8f3e4e539379b = ({ identifier: identifier, text: text, linkText: linkText, linkUrl: linkUrl, dataEventProps: dataEventProps, hasProductNavBar: hasProductNavBar })=>{
    const intl = (0, $f6qj2.default)();
    const bannerStorageItem = `BannerAlert_dismiss-${identifier}`;
    const translatedLabel = intl.formatMessage({
        id: "banner-alert.close.aria-label",
        defaultMessage: "Close"
    });
    const [isHidden, setIsHidden] = (0, $iSvIT.useState)(true);
    (0, $iSvIT.useEffect)(()=>{
        let dismissValue = null;
        dismissValue = (0, $1syhO.getLocalStorage)(bannerStorageItem);
        if (dismissValue !== "1") setIsHidden(false);
    }, [
        bannerStorageItem
    ]);
    const dynamicStyles = hasProductNavBar ? {
        marginBlockStart: "60px"
    } : {};
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "banner-alert",
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            "data-dismissed": isHidden ? "true" : undefined,
            className: (0, $esG4f.default)([
                "_bfhkuzct _kqswh2mm _y4ti1ejb _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1e0c1txw _1pbykb7n _nzmgglyw"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                    "aria-label": translatedLabel,
                    onClick: ()=>{
                        setIsHidden(true);
                        (0, $1syhO.setLocalStorage)(bannerStorageItem, "1");
                    },
                    className: (0, $esG4f.default)([
                        "_r06hglyw _bfhk1j28 _19itidpf _80omtlke _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw _rjxp1ul9 _152tpxbi _1nj119tk"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Cross), {
                        size: "20"
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    style: dynamicStyles,
                    className: (0, $esG4f.default)([
                        "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _bozgxy5q _y4tixncg _1e0c11p5 _syaz1mpp _1a9ox7w3 _oxk4oelr _rfqo1r31 _1bgkglyw _1t0pnqa1 _1d61glyw _14l354rc"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                children: text
                            }),
                            "\xa0",
                            linkText && linkUrl && /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                                text: linkText,
                                href: linkUrl,
                                type: "inline",
                                dataEventProps: dataEventProps
                            })
                        ]
                    })
                })
            ]
        })
    });
};

});


parcelRegister("kG61r", function(module, exports) {

$parcel$export(module.exports, "ADG4CtaWithPolygonBackground", function () { return $86b2c7811891ac1f$export$eacf4ba154ffd9bb; });
/* cta-with-polygon-background.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $eDoPe = parcelRequire("eDoPe");

var $91nJf = parcelRequire("91nJf");

var $5ohHq = parcelRequire("5ohHq");

var $4XrxY = parcelRequire("4XrxY");
const $86b2c7811891ac1f$var$ctaStyles = null;
const $86b2c7811891ac1f$var$h3Styles = null;
const $86b2c7811891ac1f$var$typographyOverrides = null;
const $86b2c7811891ac1f$var$polygonStyles = null;
const $86b2c7811891ac1f$export$eacf4ba154ffd9bb = ({ header: header, paragraph: paragraph, ctaText: ctaText, ctaUrl: ctaUrl, ctaLabel: ctaLabel, productKey: productKey, backgroundColor: backgroundColor = "#101214", buttonVariant: buttonVariant = "secondary", buttonColor: buttonColor = "white" })=>{
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $eDoPe.useInView)();
    const noParagraphSpacing = !paragraph ? "var(--ds-space-400, 32px)" : 0;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.TypographyStyles), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)("section", {
            ref: scrollRef,
            className: (0, $esG4f.default)([
                "_p12f1git _18s84p42 _y3gn1h6o",
                "_syaz121t _6rth4cqu",
                sectionIsVisible ? "is-visible" : ""
            ]),
            style: {
                "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
            },
            children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                style: {
                    "--background-color": backgroundColor
                },
                className: (0, $esG4f.default)([
                    "_11q76ulk _mkrz1q5k _1vthpg2b _1yt4koci",
                    "polygon"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    layout: "8",
                    children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                                className: (0, $esG4f.default)([
                                    "_1wyb1fu0 _vwz41da2 _1cqs1h67 _1jw853lb _1bys1fu0",
                                    "_syaz121t _6rth4cqu",
                                    "header h3"
                                ]),
                                style: {
                                    marginBottom: noParagraphSpacing,
                                    "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                                },
                                children: header
                            }),
                            paragraph && /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                                layout: "8",
                                children: /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                    className: (0, $esG4f.default)([
                                        "_syaz121t _6rth4cqu",
                                        ".body-lg"
                                    ]),
                                    style: {
                                        "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                                    },
                                    children: paragraph
                                })
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $91nJf.Adg4Button), {
                                variant: buttonVariant,
                                color: buttonColor,
                                colorAgainst: backgroundColor == "#101214" ? "black" : "other",
                                href: ctaUrl,
                                dataEventProps: {
                                    "data-product-key": productKey,
                                    "data-event": "clicked",
                                    "data-event-component": "linkButton",
                                    "data-event-container": "ctaSection",
                                    "data-label-english": ctaLabel
                                },
                                className: (0, $esG4f.default)([
                                    "_6rthzwfg"
                                ]),
                                children: ctaText
                            })
                        ]
                    })
                })
            })
        })
    });
};

});

parcelRegister("jq0gD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c5a34c2ff8a2778c$export$2e2bcd8739ae039; });
/* sticky-container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $gAJUc = parcelRequire("gAJUc");
const $c5a34c2ff8a2778c$var$StickyContainer = ({ children: children })=>{
    const isMultipleStickyStart = (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).wacLiftedBannerSticky);
    if (!isMultipleStickyStart) return children;
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        "data-testid": "banner-nav-combo",
        className: (0, $esG4f.default)([
            "_kqsw1if8 _152tidpf _1pbyqfx8"
        ]),
        children: children
    });
};
const $c5a34c2ff8a2778c$var$sticky = null;
var $c5a34c2ff8a2778c$export$2e2bcd8739ae039 = $c5a34c2ff8a2778c$var$StickyContainer;

});

parcelRegister("7fb7E", function(module, exports) {

$parcel$export(module.exports, "tabbedHeroSectionPagesMessages", function () { return $ba40a511116bcc38$export$4256e39427240bad; });
$parcel$export(module.exports, "tabbedHeroSectionWhiteboardsMessages", function () { return $ba40a511116bcc38$export$86b5cdc1c559b81d; });
$parcel$export(module.exports, "tabbedHeroSectionDatabasesMessages", function () { return $ba40a511116bcc38$export$505de7052a30846e; });
$parcel$export(module.exports, "tabbedHeroSectionSpacesMessages", function () { return $ba40a511116bcc38$export$954db68b244e5987; });

var $6x1qA = parcelRequire("6x1qA");
const $ba40a511116bcc38$export$4256e39427240bad = (0, $6x1qA.defineMessages)({
    tabName: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Pages.tabName",
        defaultMessage: "Pages"
    },
    contentTitle: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Pages.title.v2",
        defaultMessage: "Get everyone on the same page"
    },
    contentDescription: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Pages.description.v2",
        defaultMessage: "Take notes, plan projects, and refine ideas with flexible Confluence live docs and pages. Or let AI do it for you."
    },
    contentIconTitle: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Pages.iconsHeader",
        defaultMessage: "Create content with ease:"
    },
    contentFeaturePoint1: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Pages.icon1",
        defaultMessage: "Countless templates to get started fast"
    },
    contentFeaturePoint2: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Pages.icon2",
        defaultMessage: "Realtime collaboration with live docs, or draft and publish with pages"
    },
    contentFeaturePoint3: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Pages.icon3",
        defaultMessage: "AI editor to fill in the blanks"
    },
    contentCta: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Pages.cta",
        defaultMessage: "Try it out"
    }
});
const $ba40a511116bcc38$export$86b5cdc1c559b81d = (0, $6x1qA.defineMessages)({
    tabName: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Whiteboards.tabName",
        defaultMessage: "Whiteboards"
    },
    contentTitle: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Whiteboards.title",
        defaultMessage: "Next-gen brainstorming"
    },
    contentDescription: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Whiteboards.description",
        defaultMessage: "Capture free-flowing thoughts and collaborate on ideas with Confluence Whiteboards."
    },
    contentIconTitle: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Whiteboards.iconsHeader",
        defaultMessage: "Ideate on an infinite canvas with:"
    },
    contentFeaturePoint1: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Whiteboards.icon1",
        defaultMessage: "Brainstorming templates"
    },
    contentFeaturePoint2: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Whiteboards.icon2",
        defaultMessage: "Diagrams and flow charts"
    },
    contentFeaturePoint3: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Whiteboards.icon3",
        defaultMessage: "Team retrospectives"
    },
    contentCta: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Whiteboards.cta",
        defaultMessage: "Explore Whiteboards"
    }
});
const $ba40a511116bcc38$export$505de7052a30846e = (0, $6x1qA.defineMessages)({
    tabName: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Databases.tabName",
        defaultMessage: "Databases"
    },
    tabLozenge: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Databases.tabLozenge",
        defaultMessage: "beta"
    },
    contentTitle: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Databases.title",
        defaultMessage: "A new way to stay in sync"
    },
    contentDescription: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Databases.description",
        defaultMessage: "Add structure, sync in real-time, and visualize your team\u2019s work with Confluence Databases."
    },
    contentIconTitle: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Databases.iconsHeader",
        defaultMessage: "Connect and relate information with:"
    },
    contentFeaturePoint1: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Databases.icon1",
        defaultMessage: "Dynamic fields"
    },
    contentFeaturePoint2: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Databases.icon2",
        defaultMessage: "Configurable views"
    },
    contentFeaturePoint3: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Databases.icon3",
        defaultMessage: "Aggregated data sources"
    },
    contentCta: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Databases.cta",
        defaultMessage: "Explore Databases"
    }
});
const $ba40a511116bcc38$export$954db68b244e5987 = (0, $6x1qA.defineMessages)({
    tabName: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Spaces.tabName",
        defaultMessage: "Spaces"
    },
    contentTitle: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Spaces.title",
        defaultMessage: "Find what you need"
    },
    contentDescription: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Spaces.description",
        defaultMessage: "Organize knowledge across teams, projects, and goals with Spaces in Confluence."
    },
    contentIconTitle: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Spaces.iconsHeader",
        defaultMessage: "Discover relevant information with:"
    },
    contentFeaturePoint1: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Spaces.icon1",
        defaultMessage: "Structured page tree"
    },
    contentFeaturePoint2: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Spaces.icon2",
        defaultMessage: "Centralized access to knowledge"
    },
    contentFeaturePoint3: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Spaces.icon3",
        defaultMessage: "Customizable permissions"
    },
    contentCta: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Spaces.cta",
        defaultMessage: "Explore knowledge sharing"
    }
});

});

parcelRegister("bGE1b", function(module, exports) {
$parcel$export(module.exports, "Adg4TextUnderline", function () { return (parcelRequire("1p5F6")).Adg4TextUnderline; });
parcelRequire("1p5F6");

});
parcelRegister("1p5F6", function(module, exports) {

$parcel$export(module.exports, "Adg4TextUnderline", function () { return $23a59b9be0d723ab$export$a8ef4069b9c5e8b7; });
/* text-underline.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $eDoPe = parcelRequire("eDoPe");
const $23a59b9be0d723ab$var$textStyle = null;
const $23a59b9be0d723ab$var$inViewTextStyle = null;
const $23a59b9be0d723ab$var$underlineStyle = null;
const $23a59b9be0d723ab$var$inViewUnderlineStyle = null;
const $23a59b9be0d723ab$var$hiddenText = null;
const $23a59b9be0d723ab$var$visibleText = null;
const $23a59b9be0d723ab$export$a8ef4069b9c5e8b7 = ({ text: text, children: children, underline: underline, underlineInset: underlineInset = "-37.5%", underlineLeft: underlineLeft = false, fontWeight: fontWeight = {
    from: 400,
    to: 800
}, useInViewOptions: useInViewOptions })=>{
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $eDoPe.useInView)(useInViewOptions);
    const fontWeightAnimation = null;
    const underlineInsetStyle = null;
    const toFontWeight = null;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("span", {
        ref: scrollRef,
        className: (0, $esG4f.default)([
            "_1e0c116y _19pkidpf _2hwxidpf _otyridpf _18u0idpf _kqswh2mm _ju251bs3 _5sagfnf5 _tip8kb7n _1o51q7pw _vwz4kb7n _1nmz1hna",
            sectionIsVisible && "_j7hq1dkr"
        ]),
        style: {
            "--_15xzfe0": (0, $43MIc.default)(fontWeight.from),
            "--_1bgzcf7": (0, $43MIc.default)(fontWeight.to)
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                "aria-hidden": true,
                className: (0, $esG4f.default)([
                    "_3um015vq _lcxvglyw",
                    "_k48p103h"
                ]),
                style: {
                    "--_1bgzcf7": (0, $43MIc.default)(fontWeight.to)
                },
                children: text !== null && text !== void 0 ? text : children
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                className: (0, $esG4f.default)([
                    "_kqswstnw _1e02idpf"
                ]),
                children: text !== null && text !== void 0 ? text : children
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _1bsb1osq _mkrz16t8 _ju251bs3 _5sagpwmj _tip8kb7n _1e02idpf _1o51q7pw _kqswstnw _1pby1mrw",
                    "_u7co11y5 _cjf710zq _1kni10zq",
                    sectionIsVisible && "_j7hqzu28"
                ]),
                style: {
                    "--_1jmpxqi": (0, $43MIc.default)(underlineInset),
                    "--_p0j3r4": (0, $43MIc.default)(underlineLeft ? "0" : "auto")
                },
                children: underline
            })
        ]
    });
};

});


parcelRegister("7fq8b", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::471b5e5cdc883753bc3e3b52ee5ae2e2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $546e343250e73767$var$_react = $546e343250e73767$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $546e343250e73767$var$_baseNew = $546e343250e73767$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $546e343250e73767$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Backlog".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for backlogs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $546e343250e73767$var$BacklogIcon = (props)=>/*#__PURE__*/ $546e343250e73767$var$_react.default.createElement($546e343250e73767$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2.167h11V3a.5.5 0 0 0-.5-.5zm10.5 4.167h-11v2.666h11zm0 4.166h-11V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5z" clip-rule="evenodd"/>`
    }, props));
$546e343250e73767$var$BacklogIcon.displayName = "BacklogIcon";
var $546e343250e73767$var$_default = module.exports.default = $546e343250e73767$var$BacklogIcon;

});

parcelRegister("20L2t", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::84a07eff465bcaaea8db49f0fc7877da>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $177011d2e77c7e3d$var$_react = $177011d2e77c7e3d$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $177011d2e77c7e3d$var$_baseNew = $177011d2e77c7e3d$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $177011d2e77c7e3d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Department".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for departments, reporting lines, or other tree chart representations.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $177011d2e77c7e3d$var$DepartmentIcon = (props)=>/*#__PURE__*/ $177011d2e77c7e3d$var$_react.default.createElement($177011d2e77c7e3d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.5.75A.75.75 0 0 1 6.25 0h3.5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75h-1v2.25h3.125c.76 0 1.375.616 1.375 1.375V11h1a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75v-3.5a.75.75 0 0 1 .75-.75h1V8.75h-7.5V11h1a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75v-3.5a.75.75 0 0 1 .75-.75h1V8.625c0-.76.616-1.375 1.375-1.375H7.25V5h-1a.75.75 0 0 1-.75-.75zM7 1.5v2h2v-2zm-4.5 11v2h2v-2zm9 0v2h2v-2z" clip-rule="evenodd"/>`
    }, props));
$177011d2e77c7e3d$var$DepartmentIcon.displayName = "DepartmentIcon";
var $177011d2e77c7e3d$var$_default = module.exports.default = $177011d2e77c7e3d$var$DepartmentIcon;

});

parcelRegister("aRydc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e8b466fb905db85ecf24180397d24c4f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7e896462d00fee46$var$_react = $7e896462d00fee46$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $7e896462d00fee46$var$_baseNew = $7e896462d00fee46$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $7e896462d00fee46$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7e896462d00fee46$var$EditIcon = (props)=>/*#__PURE__*/ $7e896462d00fee46$var$_react.default.createElement($7e896462d00fee46$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.586.854a2 2 0 0 1 2.828 0l.732.732a2 2 0 0 1 0 2.828L10.01 9.551a2 2 0 0 1-.864.51l-3.189.91a.75.75 0 0 1-.927-.927l.91-3.189a2 2 0 0 1 .51-.864zm1.768 1.06a.5.5 0 0 0-.708 0l-.585.586L13.5 3.94l.586-.586a.5.5 0 0 0 0-.708zM12.439 5 11 3.56 7.51 7.052a.5.5 0 0 0-.128.216l-.54 1.891 1.89-.54a.5.5 0 0 0 .217-.127zM3 2.501a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V10H15v3.001a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-10a2 2 0 0 1 2-2h3v1.5z" clip-rule="evenodd"/>`
    }, props));
$7e896462d00fee46$var$EditIcon.displayName = "EditIcon";
var $7e896462d00fee46$var$_default = module.exports.default = $7e896462d00fee46$var$EditIcon;

});

parcelRegister("g0xEi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a7c8caaba4b6537db98d2e63ce6d8f75>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ba76bf61c8eefd7a$var$_react = $ba76bf61c8eefd7a$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $ba76bf61c8eefd7a$var$_baseNew = $ba76bf61c8eefd7a$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $ba76bf61c8eefd7a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PersonAdd".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for adding a user to an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ba76bf61c8eefd7a$var$PersonAddIcon = (props)=>/*#__PURE__*/ $ba76bf61c8eefd7a$var$_react.default.createElement($ba76bf61c8eefd7a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M1 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m11.25 4.75V11h1.5V8.75H16v-1.5h-2.25V5h-1.5v2.25H10v1.5zm-8.5 1.75a2.25 2.25 0 0 0-2.25 2.25V15H0v-2.25A3.75 3.75 0 0 1 3.75 9h2.5A3.75 3.75 0 0 1 10 12.75V15H8.5v-2.25a2.25 2.25 0 0 0-2.25-2.25z" clip-rule="evenodd"/>`
    }, props));
$ba76bf61c8eefd7a$var$PersonAddIcon.displayName = "PersonAddIcon";
var $ba76bf61c8eefd7a$var$_default = module.exports.default = $ba76bf61c8eefd7a$var$PersonAddIcon;

});

parcelRegister("eH5ui", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::045b0e6f318b6cb40cf896c360eca820>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ab29569377c90e7c$var$_react = $ab29569377c90e7c$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $ab29569377c90e7c$var$_baseNew = $ab29569377c90e7c$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $ab29569377c90e7c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Teams".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for teams in Atlassian.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ab29569377c90e7c$var$TeamsIcon = (props)=>/*#__PURE__*/ $ab29569377c90e7c$var$_react.default.createElement($ab29569377c90e7c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 2.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M1 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0m11-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M9 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0M3.75 9.5a2.25 2.25 0 0 0-2.25 2.25V13a.5.5 0 0 0 .5.5h4V15H2a2 2 0 0 1-2-2v-1.25A3.75 3.75 0 0 1 3.75 8h1.149a3.75 3.75 0 0 1 3.524 2.469l.564 1.55A2.25 2.25 0 0 0 11.1 13.5H14a.5.5 0 0 0 .5-.5v-1.25a2.25 2.25 0 0 0-2.25-2.25H12c-.775 0-1.258.06-1.531.112-.137.026-.22.05-.26.062l-.027.01.007-.003.01-.004.005-.003.003-.002h.002c.001-.001.001-.001-.334-.672l-.335-.671h.001l.002-.002.004-.001.008-.004.018-.008a1 1 0 0 1 .174-.066q.156-.053.44-.11C10.572 8.065 11.15 8 12 8h.25A3.75 3.75 0 0 1 16 11.75V13a2 2 0 0 1-2 2h-2.899a3.75 3.75 0 0 1-3.524-2.469l-.564-1.55A2.25 2.25 0 0 0 4.9 9.5z" clip-rule="evenodd"/>`
    }, props));
$ab29569377c90e7c$var$TeamsIcon.displayName = "TeamsIcon";
var $ab29569377c90e7c$var$_default = module.exports.default = $ab29569377c90e7c$var$TeamsIcon;

});

parcelRegister("foKoE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5f93e34be6622a1cb8208e9984b09a45>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b35d164c36c1b05f$var$_react = $b35d164c36c1b05f$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $b35d164c36c1b05f$var$_baseNew = $b35d164c36c1b05f$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $b35d164c36c1b05f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Lightbulb".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: learnings in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b35d164c36c1b05f$var$LightbulbIcon = (props)=>/*#__PURE__*/ $b35d164c36c1b05f$var$_react.default.createElement($b35d164c36c1b05f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M10 12.5H6V14a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5zm-2-11c-3.022 0-4.935 3.243-3.473 5.888L5.535 9.21c.303.548.463 1.164.465 1.79h4a3.7 3.7 0 0 1 .465-1.79l1.008-1.822C12.935 4.743 11.022 1.5 8 1.5M11.5 14a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2v-2.988a2.2 2.2 0 0 0-.277-1.075L3.215 8.114C1.2 4.47 3.835 0 8 0c4.164 0 6.8 4.47 4.785 8.114l-1.008 1.823a2.2 2.2 0 0 0-.277 1.075z"/>`
    }, props));
$b35d164c36c1b05f$var$LightbulbIcon.displayName = "LightbulbIcon";
var $b35d164c36c1b05f$var$_default = module.exports.default = $b35d164c36c1b05f$var$LightbulbIcon;

});

parcelRegister("4Bezw", function(module, exports) {
$parcel$export(module.exports, "TabsWithCards", function () { return (parcelRequire("g5uJU")).TabsWithCards; });
parcelRequire("g5uJU");

});
parcelRegister("g5uJU", function(module, exports) {

$parcel$export(module.exports, "TabsWithCards", function () { return $bc1fe4aca38ac20e$export$3c855d4d211f5f7e; });
/* tabs-with-cards.pattern.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");
parcelRequire("iSvIT");

var $cutM5 = parcelRequire("cutM5");

var $5ohHq = parcelRequire("5ohHq");

var $4XrxY = parcelRequire("4XrxY");
const $bc1fe4aca38ac20e$var$Tab = ({ title: title, isSelected: isSelected, dataEventProps: dataEventProps })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("button", (0, $6iHNw._)((0, $7Knp0._)({}, dataEventProps), {
        className: (0, $esG4f.default)([
            "_1ul9ymf6 _bfhk17fj _4cvr1h6o _1bah1h6o _vchhusvi _1e0c1txw _y3gn1h6o _4bfu1r31 _1hmsglyw _ajmmnqa1 _4t3i12am _2rko1f4h _y4ti1ul9 _bozg1ul9 _80omtlke _19it1hmt _ect4lnmy _k48p1nn1 _1wybgktf _1dbzzucj _1bg41b66 _nt751hlo",
            isSelected && "_19it8djs _bfhk1ybm"
        ]),
        style: {
            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
            "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue")),
            "--_1hkddbi": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue100"))
        },
        children: title
    }));
};
const $bc1fe4aca38ac20e$export$3c855d4d211f5f7e = ({ h2Text: h2Text, tabsData: tabsData })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        id: "tabs",
        className: (0, $esG4f.default)([
            "_1bsb1osq"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $cutM5.Adg4Tabs), {
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    layout: "8",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                        className: (0, $esG4f.default)([
                            "_1bsb1osq _y3gn1h6o _6rthidpf"
                        ]),
                        children: h2Text
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $cutM5.Adg4DraggableTabList), {
                    rowGap: "12px",
                    className: (0, $esG4f.default)([
                        "_ca0q1ylp _u5f31wqb _n3td1qjk _19bv1wqb _1kmx1ylp _1ggmzwfg _1ykz1ul9 _1maezwfg",
                        "tab-list"
                    ]),
                    children: tabsData.map((tab, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $cutM5.Adg4DraggableTab), {
                            tabIndex: index,
                            className: "round-tab",
                            children: /*#__PURE__*/ (0, $loA2J.jsx)($bc1fe4aca38ac20e$var$Tab, {
                                title: tab.title,
                                dataEventProps: {
                                    "data-product-key": "home",
                                    "data-event": "clicked",
                                    "data-event-component": "button",
                                    "data-event-container": "tabsMenu",
                                    "data-label": tab.title,
                                    "data-label-english": tab.englishLabel
                                }
                            })
                        }, index))
                }),
                tabsData.map((tab, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $cutM5.Adg4TabPanel), {
                        panelIndex: index,
                        id: tab.id,
                        children: tab.tabComponent
                    }, index))
            ]
        })
    });
};
const $bc1fe4aca38ac20e$var$sectionStyles = null;
const $bc1fe4aca38ac20e$var$h2Styles = null;
const $bc1fe4aca38ac20e$var$tabList = null;
const $bc1fe4aca38ac20e$var$tabStyles = null;
const $bc1fe4aca38ac20e$var$currentStyle = null;

});


parcelRegister("efepR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cef5c4644cdf7bf7$export$2e2bcd8739ae039; });
/* tabs-content.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $iSvIT = parcelRequire("iSvIT");

var $vqrsL = parcelRequire("vqrsL");

var $bhreu = parcelRequire("bhreu");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");

var $4XrxY = parcelRequire("4XrxY");

var $aOuDE = parcelRequire("aOuDE");
const $cef5c4644cdf7bf7$var$settings = {
    arrows: false,
    centerMode: true,
    dots: true,
    infinite: false,
    swipeToSlide: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
}; // Source https://github.com/kenwheeler/slick/blob/master/slick/slick.css
// FIXME: Nested selectors are used here to target dynamically inserted child elements
const $cef5c4644cdf7bf7$var$slickStyle = null;
const $cef5c4644cdf7bf7$var$TabsContent = (tabsContentProps)=>{
    var _tabsContentProps_contentLink, _tabsContentProps_contentLink1, _tabsContentProps_contentLink2;
    const isMobile = (0, $aOuDE.useIsMobile)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.TypographyStyles), {
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_y44v951u",
                tabsContentProps.className || ""
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_dm2511p5 _1rqtaigu _pdlmzwfg"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                className: (0, $esG4f.default)([
                                    "_uhi5kb7n _eao7qfx8"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                        className: (0, $esG4f.default)([
                                            "_kzvi1txw _1gzvzwfg",
                                            "content-list"
                                        ]),
                                        children: tabsContentProps.contentList.map((content, index)=>/*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                                className: (0, $esG4f.default)([
                                                    "_xlt17vkz _40tuftgi _1tnt1tcg _v9tzum4z _p6svglyw",
                                                    "content-text"
                                                ]),
                                                style: {
                                                    "--_r91gx3": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light400"))
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                                                        className: (0, $esG4f.default)([
                                                            "_6rthidpf _1pfhidpf",
                                                            content === null || content === void 0 ? void 0 : content.headerType
                                                        ]),
                                                        children: content.headerText
                                                    }),
                                                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                                        className: (0, $esG4f.default)([
                                                            "_476dftgi"
                                                        ]),
                                                        children: content.bodyText
                                                    })
                                                ]
                                            }, "content-" + index))
                                    }),
                                    tabsContentProps.contentLink && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                        className: (0, $esG4f.default)([
                                            "_gq9a1h6o",
                                            "link-content-container"
                                        ]),
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                                            href: tabsContentProps.contentLink.link,
                                            text: (_tabsContentProps_contentLink = tabsContentProps.contentLink) === null || _tabsContentProps_contentLink === void 0 ? void 0 : _tabsContentProps_contentLink.linkText,
                                            type: "primary",
                                            dataEventProps: {
                                                "data-product-key": (_tabsContentProps_contentLink1 = tabsContentProps.contentLink) === null || _tabsContentProps_contentLink1 === void 0 ? void 0 : _tabsContentProps_contentLink1.productKey,
                                                "data-event": "clicked",
                                                "data-event-component": "linkButton",
                                                "data-event-container": "tabsSection",
                                                "data-label-english": (_tabsContentProps_contentLink2 = tabsContentProps.contentLink) === null || _tabsContentProps_contentLink2 === void 0 ? void 0 : _tabsContentProps_contentLink2.linkLabel
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_1reo15vq _18m915vq _uhi5qfx8 _eao71mrw _1iyegktf"
                                ]),
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bhreu.Picture), (0, $6iHNw._)((0, $7Knp0._)({}, tabsContentProps.pictureProps), {
                                    className: (0, $esG4f.default)([
                                        "_rtys1osq _1jpx1f51 _mezj1osq _1oo31q9y _bna71wug _m369951u _ovn1i2wt"
                                    ])
                                }))
                            })
                        ]
                    })
                }),
                tabsContentProps.tabContentEyebrowText && /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: "tab-content-header-wrapper",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                            className: (0, $esG4f.default)([
                                "_y3gn1h6o _1pfhidpf _6rth1tcg",
                                "eyebrow-md"
                            ]),
                            children: tabsContentProps.tabContentEyebrowText
                        })
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: "tabs-content-cards",
                    children: isMobile ? /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_vnijh2mm _1ls01ule _1dtvusvi _1kb1glyw _fjwtglyw _1wv2glyw _1r6vglyw _zookglyw _8rkdglyw _1tpbmuzh _u8dlmuzh _e1ct1j28 _1t25h2mm _8lsh15vq _kuv715vq _19moidpf _1vqqidpf _m8oxidpf _bzd2idpf _snlxh2mm _1rfpidpf _104oidpf _j6fg1ule _gkdh1wug _1jbo1wug _1t4e15vq _1u35glyw _1vrb1e5h _m8yv1osq _11wpftgi _ehjsftgi _13e4ftgi _12l3ftgi _gzcot94y _1xnx1ule _6rj8idpf _k58e13la _qmn3idpf _bjmnidpf _6qh814y2 _1qzl14y2 _1dx414y2 _1n6c14y2 _1mfj1h6o _12bq1o8l _nog6tlke _1njogktf _1ssvgktf _110yidpf _1glb14y2 _1a57idpf _c30z14y2 _1yjcidpf _qop8idpf _63deidpf _l4aeidpf _1jkiidpf _1xco1ule _je42idpf _176uidpf _rtji14y2 _1jth14y2 _9af414y2 _9uha14y2 _11votlke _omsfgktf _6fzegktf _5l3c1j28 _iygb1j28 _c2ls1r31 _6ejeglyw _1e79idpf _54up1hlo _1gdw1osq _cshx1hlo _2g951ssb _1f1o1mp2 _z3otldb6 _w1ixgktf _1kauidpf _fcd11h6o _slqlidpf _4if1gktf _vcsd13la _1wxl1h6o"
                        ]),
                        style: {
                            "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                        },
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($vqrsL))), (0, $6iHNw._)((0, $7Knp0._)({}, $cef5c4644cdf7bf7$var$settings), {
                            children: tabsContentProps.cardsContent.map((cardContent, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, {
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)($cef5c4644cdf7bf7$var$TabCard, (0, $7Knp0._)({}, cardContent))
                                }, "card-" + index))
                        }))
                    }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
                        layout: "4-4-4",
                        containerType: "ul",
                        children: tabsContentProps.cardsContent.map((cardContent, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, {
                                children: /*#__PURE__*/ (0, $loA2J.jsx)($cef5c4644cdf7bf7$var$TabCard, (0, $6iHNw._)((0, $7Knp0._)({}, cardContent), {
                                    containerType: "li"
                                }))
                            }, "card-" + index))
                    })
                })
            ]
        })
    });
};
const $cef5c4644cdf7bf7$var$slidein = null;
const $cef5c4644cdf7bf7$var$wrapperStyles = null;
const $cef5c4644cdf7bf7$var$bigImgWrapperStyles = null;
const $cef5c4644cdf7bf7$var$contentListWrapperStyle = null;
const $cef5c4644cdf7bf7$var$contentListTextWrapperStyle = null;
const $cef5c4644cdf7bf7$var$contentListStyles = null;
const $cef5c4644cdf7bf7$var$contentImageStyle = null;
const $cef5c4644cdf7bf7$var$eyebrowStyle = null;
const $cef5c4644cdf7bf7$var$ContentTextStyles = null;
const $cef5c4644cdf7bf7$var$ContentTextPStyle = null;
const $cef5c4644cdf7bf7$var$contentListHeaderStyle = null;
const $cef5c4644cdf7bf7$var$linkContainerStyle = null;
const $cef5c4644cdf7bf7$var$TabCard = (cardContentProps)=>{
    const { eyebrowText: eyebrowText, headerText: headerText, bodyText: bodyText, ctaProps: ctaProps, pictureProps: pictureProps, containerType: containerType } = cardContentProps;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Card), {
        title: headerText,
        titleAs: "h3",
        image: pictureProps,
        body: bodyText,
        eyebrow: eyebrowText,
        callToAction: ctaProps,
        containerType: containerType
    });
};
var $cef5c4644cdf7bf7$export$2e2bcd8739ae039 = $cef5c4644cdf7bf7$var$TabsContent;

});

parcelRegister("4w8Rb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::56a48b6e9d6992ba3e844b7827f74013>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $34a10561d56b8ab8$var$_react = $34a10561d56b8ab8$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $34a10561d56b8ab8$var$_baseNew = $34a10561d56b8ab8$var$_interopRequireDefault((parcelRequire("bTGUY")));
function $34a10561d56b8ab8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "RoadmapsPlan".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for roadmaps plan.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $34a10561d56b8ab8$var$RoadmapsPlanIcon = (props)=>/*#__PURE__*/ $34a10561d56b8ab8$var$_react.default.createElement($34a10561d56b8ab8$var$_baseNew.default, Object.assign({
        name: "RoadmapsPlanIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3.5 2.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2M1 3.5a2.5 2.5 0 0 1 4.886-.75h4.864a3 3 0 1 1 0 6h-5.5a1.5 1.5 0 1 0 0 3h4.865a2.501 2.501 0 1 1 0 1.5H5.25a3 3 0 1 1 0-6h5.5a1.5 1.5 0 0 0 0-3H5.886A2.501 2.501 0 0 1 1 3.5m11.5 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$34a10561d56b8ab8$var$RoadmapsPlanIcon.displayName = "RoadmapsPlanIcon";
var $34a10561d56b8ab8$var$_default = module.exports.default = $34a10561d56b8ab8$var$RoadmapsPlanIcon;

});

parcelRegister("fZtyx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f5f2152e50a3b99db24df80b6d3e591d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ba437ab8ef18585b$var$_react = $ba437ab8ef18585b$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $ba437ab8ef18585b$var$_baseNew = $ba437ab8ef18585b$var$_interopRequireDefault((parcelRequire("bTGUY")));
function $ba437ab8ef18585b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PageLiveDoc".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Live Document content type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ba437ab8ef18585b$var$PageLiveDocIcon = (props)=>/*#__PURE__*/ $ba437ab8ef18585b$var$_react.default.createElement($ba437ab8ef18585b$var$_baseNew.default, Object.assign({
        name: "PageLiveDocIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-9 5H1V7h5zM6 14H1v-1.5h5zm2.72-6.78a.75.75 0 0 1 .79-.17l6 2.25a.75.75 0 0 1-.08 1.43l-2.56.64-.64 2.56a.75.75 0 0 1-1.43.08l-2.25-6a.75.75 0 0 1 .17-.79" clip-rule="evenodd"/>`
    }, props));
$ba437ab8ef18585b$var$PageLiveDocIcon.displayName = "PageLiveDocIcon";
var $ba437ab8ef18585b$var$_default = module.exports.default = $ba437ab8ef18585b$var$PageLiveDocIcon;

});

parcelRegister("auB13", function(module, exports) {

$parcel$export(module.exports, "GWP8238AcquisitionBanner", function () { return $29a6ad693cea50fd$export$21516a4ccbdd4e52; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $dyZbY = parcelRequire("dyZbY");

var $3FBn4 = parcelRequire("3FBn4");

var $gAJUc = parcelRequire("gAJUc");

var $47768 = parcelRequire("47768");
const $29a6ad693cea50fd$var$AcquisitionAnnouncementDetail = ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
        id: "BannerAlert.gwp-8238-announcement.event-details",
        defaultMessage: "<strong>Breaking news:</strong> DX to join Atlassian!",
        values: (0, $3FBn4.DEFAULT_VALUES)
    });
const $29a6ad693cea50fd$export$21516a4ccbdd4e52 = ({ productKey: productKey, identifier: identifier, ufoSegmentName: ufoSegmentName, testId: testId, linkTextId: linkTextId = "BannerAlert.gwp-8238-announcement.link-text", linkTextDefault: linkTextDefault = "Learn more" })=>{
    const intl = (0, $f6qj2.default)();
    if (!(0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).gwp8238BannerAnnouncement)) return null;
    const linkText = intl.formatMessage({
        id: linkTextId,
        defaultMessage: linkTextDefault
    });
    const acquisitionAnnouncementConfig = {
        imageProps: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/v8lbu3715h6ef46x68cmh3tl207d4l74.svg",
            alt: "DX",
            width: 50
        },
        imageMobileProps: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/v8lbu3715h6ef46x68cmh3tl207d4l74.svg",
            alt: "DX",
            width: 50
        },
        identifier: identifier,
        text: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)($29a6ad693cea50fd$var$AcquisitionAnnouncementDetail, {}),
                /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                    "data-testid": testId
                })
            ]
        }),
        mobileText: /*#__PURE__*/ (0, $loA2J.jsx)($29a6ad693cea50fd$var$AcquisitionAnnouncementDetail, {}),
        productKey: productKey,
        backgroundPreset: "gwp-8238-announcement",
        linkText: linkText,
        linkUrl: "https://www.atlassian.com/blog/announcements/atlassian-acquires-dx",
        dataEventProps: {
            "data-product-key": productKey,
            "data-event-component": "linkButton",
            "data-event-container": "announcementBanner",
            "data-event": "clicked",
            "data-label": linkText,
            "data-label-english": "Learn more"
        }
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: ufoSegmentName,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $47768.EnhancedBannerAlert), (0, $7Knp0._)({}, acquisitionAnnouncementConfig))
    });
};

});

parcelRegister("t3Z1q", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fa0a7a20e9878c1f12b50feba4970dc6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0575cc88aefdce62$var$_react = $0575cc88aefdce62$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $0575cc88aefdce62$var$_baseNew = $0575cc88aefdce62$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $0575cc88aefdce62$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WorkItems".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing multiple work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0575cc88aefdce62$var$WorkItemsIcon = (props)=>/*#__PURE__*/ $0575cc88aefdce62$var$_react.default.createElement($0575cc88aefdce62$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11.5 4a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5zM9.448 5.608l-3.167 3.75a.75.75 0 0 1-1.09.061l-.055-.06-1.584-1.876 1.146-.966 1.01 1.196 2.594-3.071zM13 10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2z"/><path fill="currentcolor" d="M14.5 11.75V7H16v4.75A3.25 3.25 0 0 1 12.75 15H5v-1.5h7.75a1.75 1.75 0 0 0 1.75-1.75"/>`
    }, props));
$0575cc88aefdce62$var$WorkItemsIcon.displayName = "WorkItemsIcon";
var $0575cc88aefdce62$var$_default = module.exports.default = $0575cc88aefdce62$var$WorkItemsIcon;

});

parcelRegister("7M1uQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::43a4f9fcd22489798c1322bda48936cf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5a8e2d490a0851af$var$_react = $5a8e2d490a0851af$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $5a8e2d490a0851af$var$_baseNew = $5a8e2d490a0851af$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $5a8e2d490a0851af$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5a8e2d490a0851af$var$CalendarIcon = (props)=>/*#__PURE__*/ $5a8e2d490a0851af$var$_react.default.createElement($5a8e2d490a0851af$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.5 2.5v2H6v-2h4v2h1.5v-2H13a.5.5 0 0 1 .5.5v3h-11V3a.5.5 0 0 1 .5-.5zm-2 5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5zm9-6.5H13a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1.5V0H6v1h4V0h1.5z" clip-rule="evenodd"/>`
    }, props));
$5a8e2d490a0851af$var$CalendarIcon.displayName = "CalendarIcon";
var $5a8e2d490a0851af$var$_default = module.exports.default = $5a8e2d490a0851af$var$CalendarIcon;

});

parcelRegister("4mM75", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::76f067d08aa7c324d1505318ade2e26f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $32de89ce2440f456$var$_react = $32de89ce2440f456$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $32de89ce2440f456$var$_baseNew = $32de89ce2440f456$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $32de89ce2440f456$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Alert".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for alerts in JSM and Compass.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $32de89ce2440f456$var$AlertIcon = (props)=>/*#__PURE__*/ $32de89ce2440f456$var$_react.default.createElement($32de89ce2440f456$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 0v3h-1.5V0zM2.123 1.063 4.172 3.11 3.11 4.17 1.063 2.124zm12.814 1.06L12.89 4.172 11.83 3.11l2.047-2.048zM4.195 5.875A1.5 1.5 0 0 1 5.69 4.5h4.62a1.5 1.5 0 0 1 1.495 1.375l.635 7.625H14V15H2v-1.5h1.56zm.87 7.625h5.87L10.31 6H5.69z" clip-rule="evenodd"/>`
    }, props));
$32de89ce2440f456$var$AlertIcon.displayName = "AlertIcon";
var $32de89ce2440f456$var$_default = module.exports.default = $32de89ce2440f456$var$AlertIcon;

});

parcelRegister("jUWXi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::54f75e2054943fb775b789c9f2b57e27>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e800fa9e8b124f98$var$_react = $e800fa9e8b124f98$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $e800fa9e8b124f98$var$_baseNew = $e800fa9e8b124f98$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $e800fa9e8b124f98$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartBar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Bar charts; Reports in JSM, Space Analytics in Confluence
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e800fa9e8b124f98$var$ChartBarIcon = (props)=>/*#__PURE__*/ $e800fa9e8b124f98$var$_react.default.createElement($e800fa9e8b124f98$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 13V1h1.5v12a.5.5 0 0 0 .5.5h12V15H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="m5.25 8.5.077.004A.75.75 0 0 1 6 9.25v2.5a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-2.5a.75.75 0 0 1 .75-.75zm4-3.5a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-6A.75.75 0 0 1 8.25 5zm4-3a.75.75 0 0 1 .75.75v9a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-9a.75.75 0 0 1 .75-.75z"/>`
    }, props));
$e800fa9e8b124f98$var$ChartBarIcon.displayName = "ChartBarIcon";
var $e800fa9e8b124f98$var$_default = module.exports.default = $e800fa9e8b124f98$var$ChartBarIcon;

});

parcelRegister("bNqWX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::de887aadbfedd5e674ee79e9bf8242ce>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $89692d04c9f53368$var$_react = $89692d04c9f53368$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $89692d04c9f53368$var$_baseNew = $89692d04c9f53368$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $89692d04c9f53368$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LobbyBell".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: risks in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $89692d04c9f53368$var$LobbyBellIcon = (props)=>/*#__PURE__*/ $89692d04c9f53368$var$_react.default.createElement($89692d04c9f53368$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 1h4v1.5H8.75v1.75h.92a4.75 4.75 0 0 1 4.72 4.225l.355 3.192A.75.75 0 0 1 14 12.5H2a.75.75 0 0 1-.745-.833l.354-3.192A4.75 4.75 0 0 1 6.33 4.25h.92V2.5H6zm.33 4.75A3.25 3.25 0 0 0 3.1 8.641L2.838 11h10.324L12.9 8.641A3.25 3.25 0 0 0 9.67 5.75zM15 13.5V15H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$89692d04c9f53368$var$LobbyBellIcon.displayName = "LobbyBellIcon";
var $89692d04c9f53368$var$_default = module.exports.default = $89692d04c9f53368$var$LobbyBellIcon;

});

parcelRegister("aLqNf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f64abe706416b0877b5dd221be64e7d7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7d6313c91c7359ed$var$_react = $7d6313c91c7359ed$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $7d6313c91c7359ed$var$_baseNew = $7d6313c91c7359ed$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $7d6313c91c7359ed$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Page".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7d6313c91c7359ed$var$PageIcon = (props)=>/*#__PURE__*/ $7d6313c91c7359ed$var$_react.default.createElement($7d6313c91c7359ed$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM12 6H4V4.5h8zm-2 3.5H4V8h6z" clip-rule="evenodd"/>`
    }, props));
$7d6313c91c7359ed$var$PageIcon.displayName = "PageIcon";
var $7d6313c91c7359ed$var$_default = module.exports.default = $7d6313c91c7359ed$var$PageIcon;

});

parcelRegister("7DwKW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2251b011785916069b749fddb2c5cd02>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $58f5959e6ceaaa31$var$_react = $58f5959e6ceaaa31$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $58f5959e6ceaaa31$var$_baseNew = $58f5959e6ceaaa31$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $58f5959e6ceaaa31$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Automation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved to represent an Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $58f5959e6ceaaa31$var$AutomationIcon = (props)=>/*#__PURE__*/ $58f5959e6ceaaa31$var$_react.default.createElement($58f5959e6ceaaa31$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.377.102a.75.75 0 0 1 .346.847L8.985 7.25h4.265a.75.75 0 0 1 .53 1.28l-7.25 7.25a.75.75 0 0 1-1.253-.73l1.738-6.3H2.75a.75.75 0 0 1-.53-1.28L9.47.22a.75.75 0 0 1 .907-.118M7.43 7.25l1.093-3.96L4.56 7.25zm1.142 1.5-1.093 3.96 3.961-3.96z" clip-rule="evenodd"/>`
    }, props));
$58f5959e6ceaaa31$var$AutomationIcon.displayName = "AutomationIcon";
var $58f5959e6ceaaa31$var$_default = module.exports.default = $58f5959e6ceaaa31$var$AutomationIcon;

});

parcelRegister("3Xdhp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c939fd7642839817f37f5fef435fb296>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2e112ed9ad5aeb06$var$_react = $2e112ed9ad5aeb06$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $2e112ed9ad5aeb06$var$_baseNew = $2e112ed9ad5aeb06$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $2e112ed9ad5aeb06$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Changes".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for changes in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2e112ed9ad5aeb06$var$ChangesIcon = (props)=>/*#__PURE__*/ $2e112ed9ad5aeb06$var$_react.default.createElement($2e112ed9ad5aeb06$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.78 4.22 11.53.97l-1.06 1.06L12.44 4H2v1.5h10.44l-1.97 1.97 1.06 1.06 3.25-3.25a.75.75 0 0 0 0-1.06M3.56 10.5l1.97-1.97-1.06-1.06-3.25 3.25a.75.75 0 0 0 0 1.06l3.25 3.25 1.06-1.06L3.56 12H14v-1.5z" clip-rule="evenodd"/>`
    }, props));
$2e112ed9ad5aeb06$var$ChangesIcon.displayName = "ChangesIcon";
var $2e112ed9ad5aeb06$var$_default = module.exports.default = $2e112ed9ad5aeb06$var$ChangesIcon;

});

parcelRegister("7Zpdo", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aff4cd926156d74fe58acdf2d87dd6f1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5d11ca1091cdc9de$var$_react = $5d11ca1091cdc9de$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $5d11ca1091cdc9de$var$_baseNew = $5d11ca1091cdc9de$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $5d11ca1091cdc9de$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Pages".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for multipe pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5d11ca1091cdc9de$var$PagesIcon = (props)=>/*#__PURE__*/ $5d11ca1091cdc9de$var$_react.default.createElement($5d11ca1091cdc9de$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM4 4h6v1.5H4zm10.5 8.75V6H16v6.75A3.25 3.25 0 0 1 12.75 16H6v-1.5h6.75a1.75 1.75 0 0 0 1.75-1.75M4 7h4.5v1.5H4z" clip-rule="evenodd"/>`
    }, props));
$5d11ca1091cdc9de$var$PagesIcon.displayName = "PagesIcon";
var $5d11ca1091cdc9de$var$_default = module.exports.default = $5d11ca1091cdc9de$var$PagesIcon;

});

parcelRegister("6Whls", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a3a8c88470e968ec08c5aa075e8f42b3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $50d59d3b5204e4f5$var$_react = $50d59d3b5204e4f5$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $50d59d3b5204e4f5$var$_baseNew = $50d59d3b5204e4f5$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $50d59d3b5204e4f5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartBubble".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Bubble and matrix charts; Matrix view in in JPD
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $50d59d3b5204e4f5$var$ChartBubbleIcon = (props)=>/*#__PURE__*/ $50d59d3b5204e4f5$var$_react.default.createElement($50d59d3b5204e4f5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 13V1h1.5v12a.5.5 0 0 0 .5.5h12V15H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="M11.27 9.01a1.38 1.38 0 1 1-1.51 1.51l-.01-.14.01-.14A1.38 1.38 0 0 1 11.13 9zM5.75 6.5a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5m4.75-5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5"/>`
    }, props));
$50d59d3b5204e4f5$var$ChartBubbleIcon.displayName = "ChartBubbleIcon";
var $50d59d3b5204e4f5$var$_default = module.exports.default = $50d59d3b5204e4f5$var$ChartBubbleIcon;

});

parcelRegister("elfku", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9d288013ed94ec7ddbe1bb143e39a4fc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a70eeaf536306268$var$_react = $a70eeaf536306268$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $a70eeaf536306268$var$_baseNew = $a70eeaf536306268$var$_interopRequireDefault((parcelRequire("bTGUY")));
function $a70eeaf536306268$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "BrowserExtension".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for chrome extensions
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a70eeaf536306268$var$BrowserExtensionIcon = (props)=>/*#__PURE__*/ $a70eeaf536306268$var$_react.default.createElement($a70eeaf536306268$var$_baseNew.default, Object.assign({
        name: "BrowserExtensionIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.25 2v.5h2.25a2 2 0 0 1 2 2v2.25h.5a2 2 0 1 1 0 4h-.5V13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-2.25a.75.75 0 0 1 .75-.75h.5a1.25 1.25 0 1 0 0-2.5h-.5A.75.75 0 0 1 1 6.75V4.5a2 2 0 0 1 2-2h2.25V2a2 2 0 1 1 4 0M2.5 4.5A.5.5 0 0 1 3 4h8.5a.5.5 0 0 1 .5.5V13a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5v-1.511a2.75 2.75 0 0 0 0-5.478z" clip-rule="evenodd"/>`
    }, props));
$a70eeaf536306268$var$BrowserExtensionIcon.displayName = "BrowserExtensionIcon";
var $a70eeaf536306268$var$_default = module.exports.default = $a70eeaf536306268$var$BrowserExtensionIcon;

});

parcelRegister("3SkcQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::62b2367dcefa534d3cc5e1a7e205b220>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2d2616ca0d7754f7$var$_react = $2d2616ca0d7754f7$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $2d2616ca0d7754f7$var$_baseNew = $2d2616ca0d7754f7$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $2d2616ca0d7754f7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Goal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for goals in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2d2616ca0d7754f7$var$GoalIcon = (props)=>/*#__PURE__*/ $2d2616ca0d7754f7$var$_react.default.createElement($2d2616ca0d7754f7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 8a4 4 0 1 1 8 0 4 4 0 0 1-8 0" clip-rule="evenodd"/>`
    }, props));
$2d2616ca0d7754f7$var$GoalIcon.displayName = "GoalIcon";
var $2d2616ca0d7754f7$var$_default = module.exports.default = $2d2616ca0d7754f7$var$GoalIcon;

});

parcelRegister("4TbFb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ab25c6896d727bd4806885f3b789ade9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $38f558929341d75e$var$_react = $38f558929341d75e$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $38f558929341d75e$var$_baseNew = $38f558929341d75e$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $38f558929341d75e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Bug".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: Request types in JSM, bugs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $38f558929341d75e$var$BugIcon = (props)=>/*#__PURE__*/ $38f558929341d75e$var$_react.default.createElement($38f558929341d75e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 2.5A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 8 2.5m3 1.52V4a3 3 0 0 0-6 0v.02c-.29.05-.553.182-.761.372l-.887-.633-.917-2.064-1.37.61.944 2.125c.09.204.234.38.416.51l1.325.946V7H.5v1.5h3.25v1.149l-1.15.958a1.25 1.25 0 0 0-.318.401L1.08 13.415l1.342.67 1.18-2.36.46-.383A4.25 4.25 0 0 0 8.001 14h.249A4 4 0 0 0 12 11.393l.4.333 1.18 2.36 1.34-.671-1.202-2.407a1.25 1.25 0 0 0-.318-.401l-1.15-.958V8.5h3.25V7h-3.25V5.886l1.325-.946a1.25 1.25 0 0 0 .416-.51l.944-2.125-1.37-.61-.917 2.064-.887.633A1.5 1.5 0 0 0 11 4.02M10.75 10V5.5h-5.5v4.443l.035.226A2.75 2.75 0 0 0 8 12.5h.249a2.5 2.5 0 0 0 2.5-2.5" clip-rule="evenodd"/>`
    }, props));
$38f558929341d75e$var$BugIcon.displayName = "BugIcon";
var $38f558929341d75e$var$_default = module.exports.default = $38f558929341d75e$var$BugIcon;

});

parcelRegister("iSfb0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0b5a64a2ca9b8ddc91e264b2e4d54e26>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dbd90adf4f00ef86$var$_react = $dbd90adf4f00ef86$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $dbd90adf4f00ef86$var$_baseNew = $dbd90adf4f00ef86$var$_interopRequireDefault((parcelRequire("bTGUY")));
function $dbd90adf4f00ef86$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Notepad".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Whiteboard component 'card'
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dbd90adf4f00ef86$var$NotepadIcon = (props)=>/*#__PURE__*/ $dbd90adf4f00ef86$var$_react.default.createElement($dbd90adf4f00ef86$var$_baseNew.default, Object.assign({
        name: "NotepadIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 1V0h1.5v1h1.75V0h1.5v1h1.75V0H12v1h1a2 2 0 0 1 2 2v7.75c0 .52-.206 1.017-.573 1.384l-3.293 3.293A1.96 1.96 0 0 1 9.75 16H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zm0 1.5H3a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h6v-3.75a.75.75 0 0 1 .75-.75h3.75V3a.5.5 0 0 0-.5-.5h-1v2h-1.5v-2H8.75v2h-1.5v-2H5.5v2H4zm8.94 9H10.5v2.44zM12 8H4V6.5h8zm-5 2v1.5H4V10z" clip-rule="evenodd"/>`
    }, props));
$dbd90adf4f00ef86$var$NotepadIcon.displayName = "NotepadIcon";
var $dbd90adf4f00ef86$var$_default = module.exports.default = $dbd90adf4f00ef86$var$NotepadIcon;

});

parcelRegister("kuew8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::840e9064aa0761adacec2a7ce2dee628>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eea1ded7df24e1fa$var$_react = $eea1ded7df24e1fa$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $eea1ded7df24e1fa$var$_baseNew = $eea1ded7df24e1fa$var$_interopRequireDefault((parcelRequire("bTGUY")));
function $eea1ded7df24e1fa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Sync".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for syncing changes and save operations.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eea1ded7df24e1fa$var$SyncIcon = (props)=>/*#__PURE__*/ $eea1ded7df24e1fa$var$_react.default.createElement($eea1ded7df24e1fa$var$_baseNew.default, Object.assign({
        name: "SyncIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 .5h4.25a.75.75 0 0 1 .75.75V5.5H5.5V2.941a9 9 0 0 0-1.094.916C3.42 4.83 2.5 6.214 2.5 8c0 1.813.817 3.18 1.871 4.11 1.079.95 2.346 1.39 3.129 1.39V15c-1.217 0-2.825-.623-4.121-1.765C2.058 12.07 1 10.312 1 8c0-2.339 1.21-4.084 2.354-5.211.308-.304.615-.567.9-.789H2zm10.621 2.266C13.942 3.93 15 5.688 15 8c0 2.338-1.204 4.079-2.344 5.201-.304.3-.607.56-.889.78H14v1.5H9.75a.75.75 0 0 1-.75-.75v-4.25h1.5v2.573a9 9 0 0 0 1.104-.921C12.584 11.166 13.5 9.787 13.5 8c0-1.813-.817-3.18-1.871-4.11C10.551 2.94 9.283 2.5 8.5 2.5V1c1.217 0 2.825.623 4.121 1.766" clip-rule="evenodd"/>`
    }, props));
$eea1ded7df24e1fa$var$SyncIcon.displayName = "SyncIcon";
var $eea1ded7df24e1fa$var$_default = module.exports.default = $eea1ded7df24e1fa$var$SyncIcon;

});


var $f788Q = parcelRequire("f788Q");

var $3nv1K = parcelRequire("3nv1K");
(0, $f788Q.init)((0, $3nv1K.HomePage));


//# sourceMappingURL=home.c599a5b5.js.map
